<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("Edit") }} {{ $t("offer") }}& {{ $t("Voucher") }}
      </div>

      <router-link class="btn-blue" to="promotions-and-offers">{{ $t("promotionsandoffer") }} {{ $t("list")
      }}</router-link>
    </div>
    <div class="white-wrapper">
      <!-- offer -->
      <section class="my-2">
        <div class="section-border container rounded-10 col-12 py-3 mb-2">
          <h5 class="heading">Settings</h5>
          <div class="row">
            <div class="col-lg-6 col-xl-3 my-2">
              <div class="input-material">
                <input v-model="offer.offer_title" name="title" id="title" v-validate="'required'" placeholder="."
                  type="text" @input="onChangeText($event, 'name')" />
                <label>{{ $t("title") }}</label>
              </div>
              <p v-if="submit.offer && errors.has('offer_title')" class="error_message">
                <span>{{ errors.first("offer_title") }}</span>
              </p>
            </div>
            <div class="col-lg-6 col-xl-3 my-2">
              <div class="input-material">
                <input disabled v-model="offer.offer_code" placeholder="." type="text" />
                <label>{{ $t("code") }}</label>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 my-2">
              <div class="dropdown-curve-container">
                <label :class="offer.selectedOfferGroupType &&
                  offer.selectedOfferGroupType.hasOwnProperty('ogt_id')
                  ? 'shift-up'
                  : 'font-weight-bold'
                  ">Offer Group Type</label>
                <div class>
                  <multiselect v-model="offer.selectedOfferGroupType" placeholder="Client"
                    :options="masterData.offerGroupTypes" label="ogt_type_name" track-by="ogt_id" :multiple="false">
                  </multiselect>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 my-2 align-self-center">
              <div class="d-flex align-items-center justify-content-left">
                <b-form-checkbox class="ml-3 j-checkbox pb-0" v-model="offer.os_is_active" unchecked-value="N"
                  value="Y"></b-form-checkbox>
                <span class="ml-1">{{ "Active" }}</span>
              </div>
            </div>
          </div>
          <div class="row">
            <!-- {{ start .date }} -->

            <!-- <div class="d-flex"> -->
            <div class="col-lg-3 col-md-6 col-12 my-2">
              <div class="input-material">
                <div class="add-datepicker custom-date">
                  <button class="btn-clearDate" v-if="offer.offer_start_date_time"
                    v-on:click="offer.offer_start_date_time = null">
                    ✖
                  </button>
                  <div class="d-flex align-items-center">
                    <Datepicker :monday-first="true" ref="programaticOpen" v-model="offer.offer_start_date_time"
                      type="date" class="theme-custom-date-time w-100" typeable id="voucher_startdate"
                      name="voucher_startdate" v-b-tooltip.hover :title="$t('start_date_tooltip')">
                    </Datepicker>
                    <!--Tooltip :title="$t('voucher_start_date_tooltip')" /-->
                  </div>
                  <label :class="offer.offer_start_date_time ? 'active' : ''">{{
                    $t("startdate")
                  }}</label>
                </div>
              </div>

              <p class="text-danger">
                <!-- <span>{{ custom_errors.voucher_start_date_error }}</span> -->
              </p>
            </div>
            <!-- </div> -->
            <!-- {{ end date }} -->
            <div class="col-lg-3 col-md-6 col-12 my-2">
              <div class="input-material">
                <div class="add-datepicker custom-date">
                  <button class="btn-clearDate" v-if="offer.offer_end_date_time"
                    v-on:click="offer.offer_end_date_time = null">
                    ✖
                  </button>
                  <div class="d-flex align-items-center">
                    <Datepicker :monday-first="true" ref="programaticOpen" v-model="offer.offer_end_date_time"
                      type="date" class="theme-custom-date-time w-100" typeable id="voucher_enddate"
                      name="voucher_enddate" v-b-tooltip.hover :title="$t('end_date_tooltip')">
                    </Datepicker>
                    <!--Tooltip :title="$t('voucher_start_date_tooltip')" /-->
                  </div>
                  <label :class="offer.offer_end_date_time ? 'active' : ''">{{
                    $t("enddate")
                  }}</label>
                </div>
              </div>
              <p class="text-danger">
                <!-- <span>{{ custom_errors.voucher_start_date_error }}</span> -->
              </p>
            </div>
            <!-- {{ start time }} -->
            <div class="col-lg-6 col-xl-3 my-2 custom-timepicker">
              <div class="d-flex justify-content-center align-items-center">
                <vue-timepicker manual-input v-model="offer.offer_start_time" id="starttime" name="starttime"
                  :placeholder="$tc('starttime')" format="HH:mm" class="time_picker" input-width="100%" auto-scroll lazy
                  v-b-tooltip.hover :title="$t('start_time')"></vue-timepicker>
                <!--Tooltip :title="$t('offer_start_time')" /-->
              </div>
            </div>
            <!-- {{ end time }} -->
            <div class="col-lg-6 col-xl-3 my-2 custom-timepicker">
              <div class="d-flex justify-content-center align-items-center">
                <vue-timepicker manual-input v-model="offer.offer_end_time" id="endtime" name="endtime"
                  :placeholder="$tc('endtime')" format="HH:mm" class="time_picker" input-width="100%" auto-scroll lazy
                  v-b-tooltip.hover :title="$t('end_time')"></vue-timepicker>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-3 my-2">
              <div class="input-material">
                <input v-model="offer.offer_description_text" placeholder="." type="text" />
                <label>{{ $t("description") }}</label>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 my-3" v-if="os_is_voucher == 'N'">
              <div class="d-flex align-items-center justify-content-start">
                <b-form-checkbox class="j-checkbox pb-0 ml-3" v-model="offer.is_offer_auth_required" unchecked-value="N"
                  value="Y"></b-form-checkbox>
                <span class="font-weight-bold">Authentication Required</span>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 my-3" v-if="titleName !== 'Offer'">
              <div class="d-flex align-items-center justify-content-start">
                <b-form-checkbox class="j-checkbox pb-0 ml-3" v-model="offer.is_redemption" unchecked-value="N"
                  value="Y"></b-form-checkbox>
                <span class="font-weight-bold">Is Redemption</span>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 my-3" v-if="os_is_voucher == 'N'">
              <div class="d-flex align-items-center">
                <b-form-checkbox class="j-checkbox pb-0 ml-3" v-model="offer.visible_on_web" unchecked-value="N"
                  value="Y"></b-form-checkbox>
                <span class="font-weight-bold">{{
                  $t("Visible On Website")
                }}</span>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 my-3" v-if="os_is_voucher == 'N'">
              <div class="d-flex align-items-center">
                <b-form-checkbox class="j-checkbox pb-0 ml-3" v-model="offer.is_package_offer" unchecked-value="N"
                  value="Y" @change="handlePackageOfferChange($event)"></b-form-checkbox>
                <span class="font-weight-bold">{{ $t("Package Offer") }}</span>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 my-3" v-if="os_is_voucher == 'N'">
              <div class="d-flex align-items-center">
                <b-form-checkbox class="j-checkbox pb-0 ml-3" v-model="offer.report_offer" unchecked-value="N"
                  value="Y"></b-form-checkbox>
                <span class="font-weight-bold">{{ $t("Report Offer") }}</span>
              </div>
            </div>
          </div>
          <div class="row d-flex justify-content-end aling-items-center pr-2 py-2">
            <div class="icon-save-btn blue-icon mx-1 btn float-right" :title="'Save'" @click="updateOffer"></div>
          </div>
        </div>
      </section>

      <!-- offer content -->
      <section class="my-2" v-if="titleName === 'Offer'">
        <div class="section-border container  rounded-10 col-12 py-3 mb-2">
          <h5 class="heading">Content Configuration</h5>

          <section class="mb-2 col-lg-12 col-xl-12 align-self-center px-0">
            <div class="bn-tabs-nav mb-2">
              <button v-for="(Content,
                ContentIndex) in offerContent.offerContentArray" :key="ContentIndex" :class="[
                  'btn-tab-title',
                  { active: ContentIndex == offerContent.activeIndex },
                ]" @click.prevent.stop="onChangeTabHandler($event, ContentIndex)">
                <strong>
                  <span :class="Content.langauge.toLowerCase() !== 'english'
                    ? offerContent.notempty[ContentIndex]
                      ? ''
                      : 'text-danger'
                    : ''
                    ">{{ Content.langauge }}</span>
                </strong>
              </button>
            </div>
            <div class="bn-tabs-content">
              <div v-for="(Content,
                ContentIndex) in offerContent.offerContentArray" :key="ContentIndex">
                <div v-if="ContentIndex === offerContent.activeIndex">
                  <div class="row">
                    <div class="col-lg-6 col-xl-4 align-self-center">
                      <div class="d-flex align-items-center">
                        <div class="input-material">
                          <input placeholder="." type="text" v-model="Content.offer_title" name="offer_content_title"
                            id="offer_content_title" @input="CheckEmptyContent(Content, ContentIndex)" v-validate="Content.langauge.toLowerCase() === 'english'
                              ? 'required'
                              : ''
                              " v-b-tooltip.hover :title="$t('offer_content_title')" />
                          <label>
                            {{ $t("title") }} ({{ $t("optional") }})</label>
                        </div>
                      </div>
                      <p class="error_message">
                        <span v-if="false && errors.has('offer_content_title')">{{ errors.first("offer_content_title")
                        }}</span>
                      </p>
                    </div>

                    <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                      <div class="row align-self-center">
                        <div class="col-10">
                          <label class="material-file-upload" @click.prevent.stop="
                            setModalData(
                              offerContent.banner_image_height,
                              offerContent.banner_image_width,
                              ContentIndex,
                              1
                            )
                            ">
                            <div class="label"></div>
                            <div class="uploaded-file-name">
                              <div class="text-truncate">
                                {{
                                  Content.offer_banner_image
                                    ? Content.offer_banner_image
                                    : " Banner Image"
                                }}
                              </div>
                            </div>
                          </label>
                        </div>
                        <div class="col-1 mt-1">
                          <img width="40" height="40" class="rounded c-pointer img-preview" @click="
                            openImageModal('', Content.offer_banner_image)
                            " :src="_GetImagePath(Content.offer_banner_image)" v-if="Content.offer_banner_image" />
                          <img v-else width="35" height="35" class="rounded" alt="Empty Image"
                            src="@/assets/img/icons/empty-image.svg" />
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6 col-xl-4 align-self-center mb-3">
                      <div class="row align-self-center">
                        <div class="col-10">
                          <label class="material-file-upload" @click.prevent.stop="
                            setModalData(
                              offerContent.poster_image_height,
                              offerContent.poster_image_width,
                              ContentIndex,
                              2
                            )
                            ">
                            <div class="label"></div>
                            <div class="uploaded-file-name">
                              <div class="text-truncate">
                                {{
                                  Content.offer_poster_image
                                    ? Content.offer_poster_image
                                    : "Poster Image"
                                }}
                              </div>
                            </div>
                          </label>
                        </div>
                        <div class="col-1 mt-1">
                          <img width="40" height="40" class="rounded c-pointer img-preview" @click="
                            openImageModal('', Content.offer_poster_image)
                            " :src="_GetImagePath(Content.offer_poster_image)" v-if="Content.offer_poster_image" />
                          <img v-else width="35" height="35" class="rounded" alt="Empty Image"
                            src="@/assets/img/icons/empty-image.svg" />
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-12 align-self-center mb-4 descriptionEditor">
                      <div class="descriptionSection font-weight-bold fs-14 mb-3">
                        Description
                      </div>
                      <div class="" v-if="offerContent.isEdit">
                        <vue-editor v-model="Content.offer_description" name="page" id="page"></vue-editor>
                      </div>
                      <div class="input-material-textarea" v-else-if="
                        offerContent.isEditHtml && !offerContent.isEdit
                      ">
                        <textarea id="htmlContent" name="htmlContent" @input="
                          onChangeTranslationInput(
                            $event,
                            Content,
                            ContentIndex,
                            'offer_description'
                          )
                          " v-model="Content.offer_description" placeholder="Description" class="htmlContent" />
                      </div>
                      <div class="ql-snow" v-else>
                        <div class="ql-editor" v-html="Content.offer_description" v-if="Content.offer_description">
                        </div>
                        <div class="ql-editor text-center" v-else style="min-height: 33px">
                          No Content
                        </div>
                      </div>
                      <vue-editor style="display: none" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div class="row d-flex justify-content-between">
            <div class="col-10 row greyBackground p-2 mx-2">
              <div class="col-11 whiteBackground py-2">
                <div v-for="(signageItem,
                  signageItemIndex) in signageImageData.signageContainer" :key="signageItemIndex + 'SignageContainer'"
                  class="col-md-12 mb-3">
                  <div class="row">
                    <div class="col-3 pl-0">
                      <div class="input-material ">
                        <input type="number" v-model="signageItem.width" :disabled="signageItemIndex < 2"
                          placeholder="Set Width" />
                      </div>
                    </div>
                    <div class="col-3 pl-0">
                      <div class="input-material ">
                        <input type="number" v-model="signageItem.height" :disabled="signageItemIndex < 2"
                          placeholder="Set Height" />
                      </div>
                    </div>
                    <div class="col-3 pl-0">
                      <label class="material-file-upload c-pointer" @click.prevent.stop="
                        setModalData(
                          signageItem.height,
                          signageItem.width,
                          signageItemIndex,
                          3
                        )
                        ">
                        <div class="label" v-bind:class="{
                          'shift-up':
                            signageItem.imageUrl &&
                            signageItem.imageUrl.length > 0,
                        }">
                          <div class="text-truncate">
                            Signage Image {{ signageItemIndex + 1 }}
                          </div>
                        </div>
                        <div class="uploaded-file-name">
                          <div class="text-truncate pt-2">
                            {{ signageItem.imageUrl }}
                          </div>
                        </div>
                      </label>
                    </div>

                    <div class="col-2 align-self-start" v-if="signageItem.imageUrl">
                      <ImagePreviewer :img="_GetImagePath(signageItem.imageUrl)" :clickFunc="() => {
                        openImageModal(
                          'Signage ' + `(${signageItem.imageUrl})`,
                          signageItem.imageUrl
                        );
                      }
                        " />
                      <img v-if="signageItem.imageUrl" src="@/assets/img/icons/download.svg" height="25" width="25"
                        class="rounded cursor-pointer" @click="
                          downloadImageSignage(signageItem, signageItemIndex)
                          " />
                      <img v-if="signageItem.imageUrl" src="@/assets/img/icons/trash.svg" height="25" width="25"
                        class="rounded cursor-pointer" @click="deleteImageSignage(signageItemIndex)" />
                    </div>
                    <div class="col-1" v-if="signageItemIndex > 1">
                      <img class="rounded cursor-pointer" @click.prevent.stop="removeSignage(signageItemIndex)"
                        src="@/assets/img/icons/minus.svg" height="30" width="30" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-1 d-flex justify-content-center align-items-center border-left">
                <button @click.prevent.stop="addSignageData()" class="btn-transparent">
                  <img src="@/assets/img/icons/plus.svg" height="30" width="30" />
                </button>
              </div>
            </div>
            <div class="col-1 d-flex justify-content-end align-items-end">
              <div class="icon-save-btn blue-icon mx-1 btn float-right" :title="'Save'" @click="updateOfferContent">
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- voucher setting -->
      <section v-if="os_is_voucher == 'Y'" class="my-2">
        <div class="section-border container  rounded-10 col-12 py-3 mb-2">
          <h5 class="heading">Voucher Settings</h5>

          <div class="row col-12 d-flex justify-content-between" style="margin-left:1px;">
            <div class="d-flex">
              <div class="  align-self-center ">
                <div class="d-flex align-items-center">
                  <span>{{ $tc("voucherRedemptionperPatron") }}</span>
                  <div class="input-material-sm ">
                    <input style="text-align:right" v-model="voucherSettting.oc_redemptions_per_patron" type="number" />
                  </div>
                </div>
              </div>

              <div class="  align-self-center ml-2">
                <div class="d-flex align-items-center">
                  <span>Total {{ $tc("redemption") }}</span>
                  <div class="input-material-sm mx-2">
                    <input style="text-align:right" v-model="voucherSettting.oc_total_redemptions" type="number" />
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end align-item-center">
              <div class="icon-save-btn blue-icon mx-1 btn float-right" :title="'Save'" @click="updateVoucherSetting">
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- offer Cinema Configuration -->
      <!-- <section class="my-2">

        <div class="section-border container rounded-10 col-12 py-3 mb-2">
          <h5 class="heading">Applicable Cinemas</h5>

          <div class="row  my-3 pl-1 d-flex justify-content-between">
            <div class="d-flex align-self-center ml-4">
              <b-form-checkbox class="j-checkbox pb-0 ml-3" unchecked-value="N" value="Y"
                v-model="cinemaSettingsSection.isCinemaSettingsApplicable"
                @change="handleApplicableCinemaSettings($event)"></b-form-checkbox>
              <div>
                {{ $t("applicableforselectedcinemasclassesntickettypes") }}
              </div>
            </div>
            <div class="col-1 d-flex justify-content-end align-items-center">
              <div class="icon-save-btn blue-icon mx-1 btn float-right" :title="'Save'"
                @click="updateCinemaSettingsSection"></div>
            </div>
          </div>
          <template v-if="cinemaSettingsSection.cinemaSettings.length">
            <div class="row m-2 greyBackground mx-2 my-2 px-2 py-2"
              v-for="(settingsObj, settingsIndex) in cinemaSettingsSection.cinemaSettings" :key="settingsIndex">
              <div class="col-11">
                <div class="row whiteBackground">
                  <div class="col-12 d-flex align-items-center py-2">
                    <div class="d-flex align-items-center">

                      <span class="ml-1">Not Applicable
                      </span>
                      <b-form-checkbox v-model="settingsObj.is_settings_applicable" unchecked-value="Y" value="N"
                        class="j-checkbox pb-0 ml-2"
                        @change="makeUpdatedCinemaSettingsData(settingsIndex, 'applicableKey', '', $event)"></b-form-checkbox>
                    </div>
                  </div>
                  <div class="col-12 col-lg-2 my-2">
                    <div class="dropdown-curve-container">
                      <label :class="settingsObj.selectedCinema &&
                        settingsObj.selectedCinema.length
                        ? 'shift-up'
                        : 'font-weight-bold'
                        "> {{ $tc("cinema", 1) }}</label>
                      <multiselect v-model="settingsObj.selectedCinema" :options="settingsObj.allowedCinemaList"
                        :multiple="true" open-direction="bottom" :placeholder="$tc('Cinemas')" label="cine_name"
                        track-by="cine_id" @remove="removeSelectedCinemas(settingsIndex, $event)"
                        @input="makeUpdatedCinemaSettingsData(settingsIndex, 'cinemas', 'add', $event)">
                      </multiselect>
                    </div>
                  </div>
                  <div class="col-12 col-lg-3 my-2">
                    <div class="dropdown-curve-container">
                      <label :class="settingsObj.selectedScreens.length
                        ? 'shift-up'
                        : 'font-weight-bold'
                        "> {{ $tc("screens", 1) }}</label>
                      <multiselect v-model="settingsObj.selectedScreens" :options="settingsObj.allowedScreenList"
                        open-direction="bottom" :close-on-select="false" placeholder="Screens" label="screen_name"
                        group-values="screenData" :group-select="true" group-label="cine_name" track-by="screen_id"
                        :multiple='true' @select="makeUpdatedCinemaSettingsData(settingsIndex, 'screens', 'add')"
                        @remove="makeUpdatedCinemaSettingsData(settingsIndex, 'screens', 'remove')">
                      </multiselect>
                    </div>
                  </div>
                  <div class="col-12 col-lg-3 my-2">
                    <div class="dropdown-curve-container">
                      <label :class="settingsObj.selectedSeatTypes.length
                        ? 'shift-up'
                        : 'font-weight-bold'
                        "> Seat Types</label>
                      <multiselect v-model="settingsObj.selectedSeatTypes" :options="masterData.seatGroups"
                        open-direction="bottom" :close-on-select="false" placeholder="Seat Groups" label="sstg_name"
                        track-by="sstg_id" :multiple='true'
                        @select="makeUpdatedCinemaSettingsData(settingsIndex, 'seatGroups', 'add')"
                        @remove="makeUpdatedCinemaSettingsData(settingsIndex, 'seatGroups', 'remove')">
                      </multiselect>
                    </div>
                  </div>
                  <div class="col-12 col-lg-3 my-2">
                    <div class="dropdown-curve-container">
                      <label :class="settingsObj.selectedTickets.length
                        ? 'shift-up'
                        : 'font-weight-bold'
                        "> Ticket Types</label>
                      <multiselect v-model="settingsObj.selectedTickets" :options="masterData.ticketTypesData"
                        open-direction="bottom" :close-on-select="false" placeholder="Tickets" label="tt_name"
                        track-by="tt_id" :multiple='true'
                        @select="makeUpdatedCinemaSettingsData(settingsIndex, 'ticketTypes', 'add')"
                        @remove="makeUpdatedCinemaSettingsData(settingsIndex, 'ticketTypes', 'remove')">
                      </multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-1 greyBackground rounded-0 d-flex justify-content-center align-items-center">
                <button class="btn-transparent mb-3" @click="handleCinemaSettings('remove', settingsIndex)">
                  <img src="@/assets/img/icons/minus.svg" height="30" width="30" />
                </button>
              </div>
            </div>
            <div class="row justify-content-center">
              <button class="btn-transparent mb-3" @click="handleCinemaSettings('add')">
                <img src="@/assets/img/icons/plus.svg" height="30" width="30" />
              </button>
            </div>

          </template>

</div>

</section> -->

      <!--new offre cinema settings from heree -->
      <section class="my-2">
        <div class="section-border container rounded-10 col-12 py-3 mb-2">
          <h5 class="heading">Applicable Cinemas</h5>

          <div class="row  my-3 pl-1 d-flex justify-content-between">
            <div class="d-flex align-self-center ">
              <div class="d-flex">
                <b-form-checkbox class="j-checkbox pb-0 ml-3" unchecked-value="N" value="Y"
                  v-model="cinemaSettingsSection.isCinemaSettingsApplicable"
                  @change="handleApplicableCinemaSettings($event)"></b-form-checkbox>
                <div>
                  {{ $t("applicableforselectedcinemasclassesntickettypes") }}
                </div>
              </div>
              <div v-if="cinemaSettingsSection.isCinemaSettingsApplicable == 'Y'" class="d-flex ml-2">
                <b-form-checkbox class="j-checkbox pb-0 ml-3" unchecked-value="Y" value="N" v-model="cinemaSettingsSection.allCinemaRowNotApplicableStatus
                  " @change="handleAllRowNotApplicableStatus($event)"></b-form-checkbox>
                <div>
                  {{ $t("notapplicabletocinemas") }}
                </div>
              </div>
            </div>

            <div class="col-1 d-flex justify-content-end align-items-center">
              <div class="icon-save-btn blue-icon mx-1 btn float-right" :title="'Save'"
                @click="updateCinemaSettingsSection">
              </div>
            </div>
          </div>
          <template v-if="cinemaSettingsSection.cinemaSettings.length">
            <template v-for="(settingsObj,
              settingsIndex) in cinemaSettingsSection.cinemaSettings">
              <div v-if="settingsObj.pvcs_is_active == 'Y'" class="row  greyBackground mx-1 my-2 px-2 py-2"
                :key="settingsIndex">
                <div class="col-11">
                  <div class="row whiteBackground">
                    <div class="col-12 d-flex align-items-center py-2">
                      <div class="d-flex align-items-center" v-if="offer.is_package_offer == 'N'">
                        <span class="ml-1">Not Applicable </span>
                        <b-form-checkbox v-model="settingsObj.is_settings_applicable" unchecked-value="Y" value="N"
                          :disabled="true" class="j-checkbox pb-0 ml-2" @change="
                            makeUpdatedCinemaSettingsData(
                              settingsIndex,
                              'applicableKey',
                              '',
                              $event
                            )
                            "></b-form-checkbox>
                      </div>
                    </div>
                    <div class="col-12 col-lg-2 my-2">
                      <div class="dropdown-curve-container">
                        <label :class="settingsObj.selectedCinema &&
                          settingsObj.selectedCinema.length
                          ? 'shift-up'
                          : 'font-weight-bold'
                          ">
                          {{ $tc("cinema", 1) }}</label>
                        <multiselect v-model="settingsObj.selectedCinema" :options="settingsObj.allowedCinemaList"
                          :multiple="true" open-direction="bottom" :placeholder="$tc('Cinemas')" label="cine_name"
                          track-by="cine_id" @remove="removeSelectedCinemas(settingsIndex, $event)" @select="
                            makeUpdatedCinemaSettingsData(
                              settingsIndex,
                              'cinemas',
                              'add',
                              $event
                            )
                            ">
                        </multiselect>
                      </div>
                    </div>
                    <div class="col-12 col-lg-3 my-2">
                      <div class="dropdown-curve-container">
                        <label :class="settingsObj.selectedScreens.length
                          ? 'shift-up'
                          : 'font-weight-bold'
                          ">
                          {{ $tc("screens", 1) }}</label>
                        <multiselect v-model="settingsObj.selectedScreens" :options="settingsObj.allowedScreenList"
                          open-direction="bottom" :close-on-select="false" placeholder="Screens" label="screen_name"
                          group-values="screenData" :group-select="true" group-label="cine_name" track-by="screen_id"
                          required :multiple="true" :disabled="settingsObj.is_settings_applicable == 'N' &&
                            settingsObj.selectedSeatTypes.length > 0
                            " @select="
                              makeUpdatedCinemaSettingsData(
                                settingsIndex,
                                'screens',
                                'add'
                              )
                              " @remove="
                                makeUpdatedCinemaSettingsData(
                                  settingsIndex,
                                  'screens',
                                  'remove'
                                )
                                ">
                        </multiselect>
                      </div>
                    </div>
                    <div class="col-12 col-lg-3 my-2">
                      <div class="dropdown-curve-container">
                        <label :class="settingsObj.selectedSeatTypes.length
                          ? 'shift-up'
                          : 'font-weight-bold'
                          ">
                          Seat Types</label>
                        <multiselect v-model="settingsObj.selectedSeatTypes" :options="masterData.seatGroups"
                          open-direction="bottom" :close-on-select="false" placeholder="Seat Groups" label="sstg_name"
                          track-by="sstg_id" :multiple="true" :disabled="settingsObj.is_settings_applicable == 'N' &&
                            settingsObj.selectedScreens.length > 0
                            " @select="
                              makeUpdatedCinemaSettingsData(
                                settingsIndex,
                                'seatGroups',
                                'add'
                              )
                              " @remove="
                                makeUpdatedCinemaSettingsData(
                                  settingsIndex,
                                  'seatGroups',
                                  'remove'
                                )
                                ">
                        </multiselect>
                      </div>
                    </div>
                    <div class="col-12 col-lg-3 my-2">
                      <div class="dropdown-curve-container">
                        <label :class="settingsObj.selectedTickets.length
                          ? 'shift-up'
                          : 'font-weight-bold'
                          ">
                          Ticket Types</label>
                        <multiselect v-model="settingsObj.selectedTickets" :options="masterData.ticketTypesData"
                          open-direction="bottom" :close-on-select="false" placeholder="Tickets" label="tt_name"
                          track-by="tt_id" :multiple="true" @select="
                            makeUpdatedCinemaSettingsData(
                              settingsIndex,
                              'ticketTypes',
                              'add'
                            )
                            " @remove="
                              makeUpdatedCinemaSettingsData(
                                settingsIndex,
                                'ticketTypes',
                                'remove'
                              )
                              ">
                        </multiselect>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-1 greyBackground rounded-0 d-flex justify-content-center align-items-center">
                  <button class="btn-transparent mb-3" @click="handleCinemaSettings('remove', settingsIndex)">
                    <img src="@/assets/img/icons/minus.svg" height="30" width="30" />
                  </button>
                </div>
              </div>
            </template>
            <div class="row justify-content-center">
              <button class="btn-transparent mb-3" @click="handleCinemaSettings('add')">
                <img src="@/assets/img/icons/plus.svg" height="30" width="30" />
              </button>
            </div>
          </template>
        </div>
      </section>

      <!-- offer Movie Configuration -->
      <section class="my-2">
        <div class="section-border container rounded-10 col-12 py-3 mb-2">
          <h5 class="heading">Applicable Movies</h5>

          <div class="row py-2">
            <div class="col-3 py-2 d-flex align-items-center">
              <div class="d-flex align-items-center">
                <b-form-checkbox v-model="offerMovieConfiguration.os_is_foreign_movie_applicable
                  " unchecked-value="N" value="Y" class="j-checkbox pb-0"></b-form-checkbox>
                <span class="ml-1">Is Applicable On
                  {{ showForeignMovieSection ? "Indian" : "Foreign" }}
                  Movies</span>
              </div>
            </div>
            <div class="col-12 col-md-3 py-2 ">
              <div class="dropdown-curve-container">
                <label :class="offerMovieConfiguration.selectedMovieFormats.length > 0
                  ? 'shift-up'
                  : 'font-weight-bold'
                  ">Applicable Movie Formats</label>
                <multiselect v-model="offerMovieConfiguration.selectedMovieFormats" :options="masterData.movieFormats"
                  :close-on-select="false" placeholder="" label="mf_name" :multiple="true" track-by="mf_id">
                </multiselect>
              </div>
            </div>
          </div>

          <div class="row d-flex justify-content-between align-item-end mb-2 ml-2 rounded-10">
            <div class="row col-12 col-md-5 section-border">
              <h5 class="subheading-scoped">Show Time Between</h5>
              <div class="col-lg-6 my-2 custom-timepicker">
                <div class="d-flex justify-content-center align-items-center">
                  <vue-timepicker manual-input v-model="offerMovieConfiguration.os_time_limit_start"
                    id="osmoviestarttime" name="osmoviestarttime" placeholder="Start Time Validity" format="HH:mm"
                    class="time_picker" input-width="100%" auto-scroll lazy v-b-tooltip.hover
                    :title="$t('Start Time Validity')"></vue-timepicker>
                  <!--Tooltip :title="$t('offer_start_time')" /-->
                </div>
              </div>
              <div class="col-lg-6 my-2 custom-timepicker">
                <div class="d-flex justify-content-center align-items-center">
                  <vue-timepicker manual-input v-model="offerMovieConfiguration.os_time_limit_end" id="osmovieendtime"
                    name="osmovieendtime" placeholder="End Time Validity" format="HH:mm" class="time_picker"
                    input-width="100%" auto-scroll lazy v-b-tooltip.hover title="End Time Validity"></vue-timepicker>
                  <!--Tooltip :title="$t('offer_start_time')" /-->
                </div>
              </div>
            </div>
            <div class="row col-12 col-md-5 section-border">
              <h5 class="subheading-scoped">Select Movies</h5>
              <div class="col-12 col-md-6 py-2 d-flex align-items-center">
                <div class="d-flex align-items-center" style="margin-left: -20px;">
                  <!-- <b-form-checkbox switch class="mx-2"></b-form-checkbox> -->
                  <b-form-radio value="movies_applicable" class="j-radio ml-2 pb-0"
                    v-model="offerMovieConfiguration.movies_applicable_status"
                    @change="handleMovieApplicableChange('movies_applicable')">
                  </b-form-radio>
                  <div>
                    <span style="text-transform: capitalize">Applicable</span>
                  </div>
                  <!---strong class="mx-3">OR</strong---->

                  <!-- <b-form-checkbox switch class="mx-2"></b-form-checkbox> -->
                  <b-form-radio value="movies_not_applicable" class="j-radio ml-2 pb-0"
                    v-model="offerMovieConfiguration.movies_applicable_status" @change="
                      handleMovieApplicableChange('movies_not_applicable')
                      ">
                    <div>
                      <span>Not Applicable</span>
                    </div>
                  </b-form-radio>
                </div>
              </div>
              <div class="col-12 col-md-6 align-self-center py-2">
                <custommultiselect :options="masterData.movieList"
                  v-model="offerMovieConfiguration.selectedParticaularMovies" label="movie" :placeholder="$t(
                    offerMovieConfiguration.os_is_movie_applicable == 'Y'
                      ? 'Applicable Movies'
                      : 'Not Applicable Movies'
                  )
                    " isSingleId="md_id" :multiple="true" :close-on-select="false" track-by="md_id"
                  @select="makeActiveInactive($event, 0, 'add', 'movieList')"
                  @remove="makeActiveInactive($event, 0, 'remove', 'movieList')"></custommultiselect>
              </div>
            </div>

            <div class="col-1 d-flex justify-content-end align-items-end">
              <div class="icon-save-btn blue-icon mx-1 btn float-right" :title="'Save'" @click="updateMovieSection">
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- offer Days Configuration -->
      <section class="my-2">
        <div class="section-border container  rounded-10 col-12 py-3">
          <h5 class="heading">Days Configuration</h5>

          <div class="col-lg-12 col-xl-12 align-self-center">
            <div class="row px-1 d-flex justify-content-between align-items-center flex-wrap">
              <div class="d-flex flex-wrap">
                {{ $t("show") }} {{ $t("days") }}:
                <b-form-checkbox v-for="(weekdaysLoop,
                  weekdaysKey) in offerDaysConfiguration.weekDays" :key="weekdaysKey" value="Y" unchecked-value="N"
                  v-model="offerDaysConfiguration.weekDays[weekdaysKey]" class="j-checkbox mx-3 mb-2 pb-0"
                  @change="onChangeWeekdays($event, weekdaysKey)">
                  <div class="text-capitalize">{{ weekdaysKey }}</div>
                </b-form-checkbox>
              </div>
              <div class="icon-save-btn blue-icon btn" :title="'Save'" @click="updateDayssection"
                style="margin-left: auto;">
              </div>
            </div>
            <p v-if="custom_errors.weekday_errors" class="error_message">
              <span>{{ custom_errors.weekday_errors }}</span>
            </p>
          </div>
        </div>
      </section>

      <!-- osther setting  -->
      <section class="my-2">
        <div class="section-border container rounded-10 col-12 py-3 mb-2">
          <h5 class="heading">Other Settings</h5>
          <div class="row d-flex justify-content-between">
            <div class="col-11 row mb-2">
              <div v-if="os_is_voucher == 'N'" class="col-lg-6 col-xl-2 my-3 d-flex align-items-center">
                <div class="d-flex align-items-center justify-content-start">
                  <b-form-checkbox class="j-checkbox pb-0 ml-3" v-model="offerSettingConfiguration.is_bank_offer"
                    unchecked-value="N" value="Y" @change="onSelectBankOffer($event)"></b-form-checkbox>
                  <span class="font-weight-bold">{{
                    $t("is_bank_offer")
                  }}</span>
                </div>
              </div>
              <div class="col-lg-6 col-xl-3 my-3" v-if="offerSettingConfiguration.is_bank_offer == 'Y'">
                <div class="d-flex align-items-center">
                  <custommultiselect v-model="offerSettingConfiguration.bankDetails['selectedBank']
                    " :options="masterData.activeBankList" :placeholder="$tc('Bank')" label="bank_name"
                    isSingleId="bank_id" :multiple="false" track-by="bank_id" @select="onSelectBankv2($event)">
                  </custommultiselect>
                </div>
                <p v-if="
                  submit.other_setting &&
                  offerSettingConfiguration.is_bank_offer == 'Y' &&
                  !offerSettingConfiguration.bankDetails['bank_id']
                " class="error_message">
                  <span>{{ $tc("please") }} {{ $tc("selectBank") }}.</span>
                </p>
              </div>
              <div class="col-lg-6 col-xl-3 my-3" v-if="offerSettingConfiguration.is_bank_offer == 'Y'">
                <div class="d-flex align-items-center">
                  <multiselect v-model="offerSettingConfiguration.selectedCard" :options="masterData.activeBankCardList"
                    placeholder="card" track-by="card_id" label="card_type" :multiple="true">
                  </multiselect>
                </div>
                <p v-if="
                  submit.other_setting &&
                  offerSettingConfiguration.is_bank_offer == 'Y' &&
                  !offerSettingConfiguration.bankDetails['card_type_ids']
                " class="error_message">
                  <span>{{ $tc("please") }} {{ $tc("selectcardtype") }}.</span>
                </p>
              </div>
              <div class="col-lg-6 col-xl-3 my-3" v-if="offerSettingConfiguration.is_bank_offer == 'Y'"></div>
              <div class="col-lg-4 col-xl-3 mb-2 d-flex align-items-center">
                <div class="dropdown-curve-container mt-1">
                  <label :class="offerSettingConfiguration.clientShareSettings.client
                    ? 'shift-up'
                    : ''
                    ">{{ $tc("client") }}</label>
                  <div class>
                    <multiselect v-model="offerSettingConfiguration.clientShareSettings.client
                      " :placeholder="$tc('client')" :options="masterData.clientList" label="client_name"
                      track-by="client_id" :multiple="false">
                    </multiselect>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-xl-3 align-self-center mb-2">
                <div class="d-flex align-items-center justify-content-center">
                  <span>{{ $tc("share") }} {{ $tc("value") }}</span>
                  <div class="input-material-sm mx-2">
                    <input style="text-align: right" v-model="offerSettingConfiguration.clientShareSettings
                      .client_share_value
                      " name="share_value" id="share_value" type="text" />
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-xl-4 align-self-center mb-2" v-if="os_is_voucher == 'Y'">
                <div class="d-flex align-items-center justify-content-start">
                  <b-form-checkbox class="j-checkbox pb-0 ml-3" v-model="offerSettingConfiguration.clientShareSettings
                    .is_prepaid_voucher
                    " unchecked-value="N" value="Y"></b-form-checkbox>
                  <span class="font-weight-bold">Is Prepaid Voucher</span>
                </div>
              </div>
              <div class="col-lg-6 col-xl-4 align-self-center mb-2" v-if="
                offerSettingConfiguration.clientShareSettings
                  .is_prepaid_voucher == 'N'
              ">
                <div class="d-flex align-items-center justify-content-start">
                  <b-form-checkbox class="j-checkbox pb-0 ml-3" v-model="offerSettingConfiguration.clientShareSettings
                    .is_share_percentage
                    " unchecked-value="N" value="Y"></b-form-checkbox>
                  <span class="font-weight-bold">Client Share Is Percentage</span>
                </div>
              </div>
            </div>
            <div class="col-1 d-flex justify-content-end align-items-center">
              <div class=" icon-save-btn  blue-icon mx-1 btn float-right" :title="'Save'"
                @click="updateotherOffersSettingsSection"></div>
            </div>
          </div>
          <div v-if="isReportingFeeClient" class="row align-items-center">
            <div class="col-lg-6 col-xl-3 my-3">
              <div class="d-flex align-items-center justify-content-start">
                <b-form-checkbox class="j-checkbox pb-0 ml-3" @change="onChangeReporting($event, 'full')"
                  v-model="offerSettingConfiguration.report_full_amount" unchecked-value="N"
                  value="Y"></b-form-checkbox>
                <span class="font-weight-bold">Report full Amt.</span>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 my-3">
              <div class="d-flex align-items-center justify-content-start">
                <b-form-checkbox class="j-checkbox pb-0 ml-3" @change="onChangeReporting($event, 'full_spcl')" v-model="offerSettingConfiguration.report_full_amount_special_rc
                  " unchecked-value="N" value="Y"></b-form-checkbox>
                <span class="font-weight-bold">Report full Amt. for Spl. RC</span>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 my-3">
              <div class="d-flex align-items-center justify-content-start">
                <b-form-checkbox class="j-checkbox pb-0 ml-3" @change="onChangeReporting($event, 'specific')"
                  v-model="offerSettingConfiguration.has_o_reporting_percent" unchecked-value="N"
                  value="Y"></b-form-checkbox>
                <span class="font-weight-bold">Report Specific Percent</span>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 my-3" v-if="offerSettingConfiguration.has_o_reporting_percent == 'Y'">
              <div class="d-flex align-items-center justify-content-start">
                <span class="font-weight-bold">Reporting Percent</span>
                <div class="input-material-sm mx-2">
                  <input style="text-align: right" v-model="offerSettingConfiguration.o_reporting_percent"
                    name="dist_share_value" id="dist_share_value" type="text" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Offer type  -->
      <section class="my-2">
        <div class="section-border container  col-12 rounded-10 py-3 mb-2">
          <h5 class="heading">{{ titleName }} Types</h5>
          <div class="row">
            <div class="mx-2 mb-2" v-if="checkOfferTypeAvailable('fixedDiscount')">
              <b-form-radio value="fixedDiscount" class="j-radio" v-model="offerTypes.selectedOfferType"
                @change="onChangeOfferType($event)">
                <div>{{ $t("Fixed Discount") }}</div>
              </b-form-radio>
            </div>
            <div class="mx-2 mb-2" v-if="checkOfferTypeAvailable('buyAndGetFreeTickets')">
              <b-form-radio value="buyAndGetFreeTickets" class="j-radio" v-model="offerTypes.selectedOfferType"
                @change="onChangeOfferType($event)">
                <div>{{ $t("buyngetfreeticket") }}</div>
              </b-form-radio>
            </div>
            <div class="mx-2 mb-2" v-if="checkOfferTypeAvailable('discount')">
              <b-form-radio class="j-radio" value="discount" v-model="offerTypes.selectedOfferType">
                <div>{{ $t("discounts") }}</div>
              </b-form-radio>
            </div>

            <div class="mx-2 mb-2" v-if="checkOfferTypeAvailable('buyAndGetCombo')">
              <b-form-radio value="buyAndGetCombo" class="j-radio" v-model="offerTypes.selectedOfferType">
                <div>{{ $t("buyandgetcombo") }}</div>
              </b-form-radio>
            </div>

            <div class="mx-2 mb-2" v-if="checkOfferTypeAvailable('fixedPriceTicketFnb')">
              <b-form-radio class="j-radio" value="fixedPriceTicketFnb" v-model="offerTypes.selectedOfferType"
                @change="onChangeOfferType($event)">
                <div>{{ $t("fixedPriceTicketFnb") }}</div>
              </b-form-radio>
            </div>

            <div class="mx-2 mb-2" v-if="checkOfferTypeAvailable('buyAndgetOffOnAnother')">
              <b-form-radio class="j-radio" value="buyAndgetOffOnAnother" v-model="offerTypes.selectedOfferType"
                @change="onChangeOfferType($event)">
                <div>{{ $t("buyAndgetOffOnAnother") }}</div>
              </b-form-radio>
            </div>

            <div class="mx-2 mb-2" v-if="checkOfferTypeAvailable('loyalitycustomers')">
              <b-form-radio class="j-radio" value="loyalitycustomers" v-model="offerTypes.selectedOfferType">
                <div>{{ $t("loyalityOffers") }}</div>
              </b-form-radio>
            </div>

            <div class="mx-2 mb-2" v-if="checkOfferTypeAvailable('fnbItemDiscounts')">
              <b-form-radio class="j-radio" value="fnbItemDiscounts" @change="onChangeOfferType($event)"
                v-model="offerTypes.selectedOfferType">
                <div>{{ $t("fnbItemDiscounts") }}</div>
              </b-form-radio>
            </div>
            <div class="mx-2 mb-2" v-if="checkOfferTypeAvailable('freeTickets')">
              <b-form-radio class="j-radio" value="freeTickets" @change="onChangeOfferType($event)"
                v-model="offerTypes.selectedOfferType">
                <div>Free Tickets</div>
              </b-form-radio>
            </div>
          </div>
          <div class="row">
            <div class="col-11">
              <!-- Fixed Discount-->
              <div class="offer-content-wrapper pt-3 pl-0" v-if="offerTypes.selectedOfferType == 'fixedDiscount'">
                <div class="row pl-0 section-border mx-1 pt-2">
                  <div class="col-12 pt-2 pb-0">
                    <div class="row">
                      <div class="col-lg-10 col-xl-12">
                        <div class="row">
                          <div class="col-lg-6 col-xl-3 my-3">
                            <div class="d-flex align-items-center justify-content-start">
                              <b-form-checkbox class="j-checkbox pb-0 ml-3" :disabled="offerSettingConfiguration.is_bank_offer == 'Y'
                                " v-model="offerTypes.is_employee_offer" unchecked-value="N" value="Y"
                                @change="onSelectEmployeeDiscount($event)"></b-form-checkbox>
                              <span>{{ $t("is_employee_offer") }}</span>
                            </div>
                          </div>
                          <div class="col-lg-12 col-xl-3 align-self-center mb-2">
                            <div class="d-flex align-items-center">
                              {{ $t("Offer Value :") }}
                              <div class="input-material mx-1">
                                <input style="text-align: right" name="discount_buy_value" id="discount_buy_value"
                                  v-validate="'required'" type="number" v-model="offerTypes.fixedDiscount.oc_discount_value
                                    " @input="
                                      ($event) => {
                                        offerTypes.fixedDiscount.oc_max_discount_amount =
                                          offerTypes.fixedDiscount.oc_discount_value;
                                      }
                                    " />
                              </div>
                            </div>
                            <p v-if="
                              submit.offer_types &&
                              errors.has('discount_buy_value')
                            " class="error_message">
                              <span>{{
                                errors.first("discount_buy_value")
                              }}</span>
                            </p>
                          </div>
                          <div class="col-lg-6 col-xl-2 align-self-center mb-2">
                            <div class="d-flex align-items-center">
                              <b-form-checkbox class="j-checkbox pb-0" v-model="offerTypes.fixedDiscount
                                .oc_discount_value_is_percentage
                                " unchecked-value="N" value="Y"></b-form-checkbox>
                              {{ $t("Percentage") }}
                            </div>
                          </div>
                          <div class="col-lg-12 col-xl-4 align-self-center mb-lg-2 mb-xl-2">
                            <div class="d-flex align-items-center">
                              {{ $t("maxdiscountpertransaction") }}
                              <div class="input-material-sm mx-2">
                                <input style="text-align: right" type="number" name="max_discount_per_trans"
                                  id="max_discount_per_trans" v-validate="'required'" v-model="offerTypes.fixedDiscount
                                    .oc_max_discount_amount
                                    " />
                              </div>
                            </div>
                            <p v-if="
                              submit.offer_types &&
                              errors.has('max_discount_per_trans')
                            " class="error_message">
                              <span>{{
                                errors.first("max_discount_per_trans")
                              }}</span>
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-6 col-xl-2 align-self-center ml-3 mb-2">
                            <div class="d-flex align-items-center">
                              <b-form-checkbox class="j-checkbox pb-0" v-model="offerTypes.fixedDiscount
                                .min_amount_channel_wise
                                " unchecked-value="N" value="Y"
                                @change="onChangeChannelWise($event)"></b-form-checkbox>
                              {{ "Channel Wise" }}
                            </div>
                          </div>
                          <div class="col-lg-12 col-xl-2 mb-2 mx-0 px-0">
                            <div class="d-flex align-items-center justify-content-center">
                              <span v-if="
                                offerTypes.fixedDiscount
                                  .min_amount_channel_wise == 'Y'
                              ">{{ "Min. Ticket Amt." }}</span>
                              <span v-else>{{ "Min. Bill Amt" }}</span>
                              <div class="input-material-sm mx-2">
                                <input style="text-align: right" v-model="offerTypes.fixedDiscount.oc_min_ticket_price
                                  " type="number" name="min_ticket_amount" id="min_ticket_amount" />
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12 col-xl-2 mb-2 mx-0 px-0" v-if="
                            offerTypes.fixedDiscount
                              .min_amount_channel_wise == 'Y'
                          ">
                            <div class="d-flex align-items-center justify-content-center">
                              {{ "Min Fnb Amt." }}
                              <div class="input-material-sm mx-2">
                                <input style="text-align: right" v-model="offerTypes.fixedDiscount.oc_min_fnb_price
                                  " type="number" name="min_fnb_amount" id="min_fnb_amount" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!--Buy/Get free ticket-->
              <div class="offer-content-wrapper pl-0" style="padding-top: 20px"
                v-if="offerTypes.selectedOfferType == 'buyAndGetFreeTickets'">
                <div class="row section-border mx-1 px-2 py-3">
                  <div class="col-lg-12 col-xl-4 mb-2">
                    <div class="d-flex align-items-center">
                      {{ $t("buy") }}
                      <div class="input-material-sm mx-1">
                        <input style="text-align: right" v-model="offerTypes.buyAndGetFreeTickets.oc_buy_no_of_ticket
                          " type="number" name="buy_value" id="buy_value" v-validate="'required|numeric'" />
                      </div>
                      {{ $t("get") }}
                      <div class="input-material-sm mx-2">
                        <input v-model="offerTypes.buyAndGetFreeTickets.oc_get_free_ticket
                          " type="number" name="get_value" id="get_value" v-validate="'required|numeric'" />
                      </div>
                      {{ $t("ofticketsfree") }}
                    </div>
                    <p v-if="
                      (submit.offer_types && errors.has('buy_value')) ||
                      (submit.offer_types && errors.has('get_value'))
                    " class="error_message">
                      <span>{{
                        errors.first("buy_value") || errors.first("get_value")
                      }}</span>
                    </p>
                  </div>

                  <div class="col-lg-12 col-xl-4 mb-2">
                    <div class="d-flex align-items-center justify-content-center">
                      {{ $tc("minTicketAmount") }}
                      <div class="input-material-sm mx-2">
                        <input style="text-align: right" v-model="offerTypes.buyAndGetFreeTickets.oc_min_ticket_price
                          " type="number" name="min_ticket_amount" id="min_ticket_amount"
                          v-validate="'required|decimal'" />
                      </div>
                    </div>
                    <p v-if="
                      submit.offer_types && errors.has('min_ticket_amount')
                    " class="error_message">
                      <span>{{ errors.first("min_ticket_amount") }}</span>
                    </p>
                  </div>

                  <div class="col-lg-12 col-xl-4 mb-2">
                    <div class="d-flex align-items-center">
                      {{ $t("maxfreeticketpertransaction") }}
                      <div class="input-material-sm mx-2">
                        <input style="text-align: right" v-model="offerTypes.buyAndGetFreeTickets
                          .oc_max_no_of_ticket_per_transaction
                          " type="number" name="max_ticket" id="max_ticket" v-validate="'required|numeric'" />
                      </div>
                    </div>
                    <p v-if="submit.offer_types && errors.has('max_ticket')" class="error_message">
                      <span>{{ errors.first("max_ticket") }}</span>
                    </p>
                  </div>
                </div>
              </div>

              <!--Discount-->
              <div class="offer-content-wrapper pt-3 pl-0" v-if="offerTypes.selectedOfferType == 'discount'">
                <div class="row pl-0 section-border mx-1 pt-2">
                  <div class="col-12 pt-2 pb-0">
                    <div class="row">
                      <div class="col-lg-10 col-xl-11">
                        <div class="row">
                          <div class="col-lg-12 col-xl-6 align-self-center mb-2">
                            <div class="d-flex align-items-center">
                              {{ $t("buy") }}
                              <div class="input-material-sm mx-1">
                                <input style="text-align: right" name="discount_buy_value" id="discount_buy_value"
                                  v-validate="'required|numeric'" type="text" v-model="offerTypes.discount.oc_buy_no_of_ticket
                                    " />
                              </div>
                              {{ $t("ticket_fnbitem") }}
                              <div class="input-material-sm mx-2">
                                <input style="text-align: right" type="text" name="discount_get_value"
                                  id="discount_get_value" v-validate="'required|numeric'" v-model="offerTypes.discount.oc_discount_value
                                    " @input="handleMaxDiscount()" />
                              </div>
                            </div>
                            <p v-if="
                              (submit.offer_types &&
                                errors.has('discount_buy_value')) ||
                              (submit.offer_types &&
                                errors.has('discount_get_value'))
                            " class="error_message">
                              <span>{{
                                errors.first("discount_buy_value") ||
                                errors.first("discount_get_value")
                              }}</span>
                            </p>
                          </div>
                          <div class="col-lg-6 col-xl-2 align-self-center mb-2">
                            <div class="d-flex align-items-center">
                              <b-form-checkbox class="j-checkbox pb-0" v-model="offerTypes.discount
                                .oc_discount_value_is_percentage
                                " unchecked-value="N" value="Y"></b-form-checkbox>
                              {{ $t("Percentage") }}
                            </div>
                          </div>
                          <div class="col-lg-12 col-xl-4 align-self-center mb-lg-2 mb-xl-2">
                            <div class="d-flex align-items-center">
                              {{ $t("maxdiscountpertransaction") }}
                              <div class="input-material-sm mx-2">
                                <input style="text-align: right" type="text" name="max_discount_per_trans"
                                  id="max_discount_per_trans" v-validate="'required'" v-model="offerTypes.discount.oc_max_discount_amount
                                    " />
                              </div>
                            </div>
                            <p v-if="
                              submit.offer_types &&
                              errors.has('max_discount_per_trans')
                            " class="error_message">
                              <span>{{
                                errors.first("max_discount_per_trans")
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!--Loyality Program Offers-->
              <div class="offer-content-wrapper pt-3 pl-0" v-if="offerTypes.selectedOfferType == 'loyalitycustomers'">
                <div class="row pl-0 section-border mx-1 pt-2">
                  <div class="col-12 pt-2 pb-0">
                    <div class="row">
                      <div class="col-lg-10 col-xl-11">
                        <div class="row">
                          <div class="col-lg-12 col-xl-6 align-self-center mb-2">
                            <div class="d-flex align-items-center">
                              {{ $t("buy") }}
                              <div class="input-material-sm mx-1">
                                <input style="text-align: right" name="discount_buy_value" id="discount_buy_value"
                                  v-validate="'required|numeric'" type="text" v-model="offerTypes.loyalityProgramOffer
                                    .oc_buy_no_of_ticket
                                    " />
                              </div>
                              {{ $t("ticket_fnbitem") }}
                              <div class="input-material-sm mx-2">
                                <input style="text-align: right" type="text" name="discount_get_value"
                                  id="discount_get_value" v-validate="'required|numeric'" v-model="offerTypes.loyalityProgramOffer
                                    .oc_discount_value
                                    " />
                              </div>
                            </div>
                            <p v-if="
                              (submit.offer_types &&
                                errors.has('discount_buy_value')) ||
                              (submit.offer_types &&
                                errors.has('discount_get_value'))
                            " class="error_message">
                              <span>{{
                                errors.first("discount_buy_value") ||
                                errors.first("discount_get_value")
                              }}</span>
                            </p>
                          </div>
                          <div class="col-lg-6 col-xl-2 align-self-center mb-2">
                            <div class="d-flex align-items-center">
                              <b-form-checkbox class="j-checkbox pb-0" v-model="offerTypes.loyalityProgramOffer
                                .oc_discount_value_is_percentage
                                " unchecked-value="N" value="Y"></b-form-checkbox>
                              {{ $t("Percentage") }}
                            </div>
                          </div>
                          <div class="col-lg-12 col-xl-4 align-self-center mb-lg-2 mb-xl-2">
                            <div class="d-flex align-items-center">
                              {{ $t("maxdiscountpertransaction") }}
                              <div class="input-material-sm mx-2">
                                <input style="text-align: right" type="text" name="max_discount_per_trans"
                                  id="max_discount_per_trans" v-validate="'required'" v-model="offerTypes.loyalityProgramOffer
                                    .oc_max_discount_amount
                                    " />
                              </div>
                            </div>
                            <p v-if="
                              submit.offer_types &&
                              errors.has('max_discount_per_trans')
                            " class="error_message">
                              <span>{{
                                errors.first("max_discount_per_trans")
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!--Buy And Get Como-->
              <div class="offer-content-wrapper py-0 pl-0" v-if="offerTypes.selectedOfferType == 'buyAndGetCombo'">
                <div class="row section-border p-2 mx-1 mt-3">
                  <div class="col-lg-12 col-xl-12 align-self-center mb-4 pl-0">
                    <div class="d-flex">
                      {{ $t("combinewith") }}:
                      <b-form-radio value="fAndb" class="j-radio ml-4"
                        v-model="offerTypes.buyAndGetCombo.offerApplicableAt">
                        <div>F&amp;B</div>
                      </b-form-radio>
                      <b-form-radio value="boxOffice" class="j-radio ml-3"
                        v-model="offerTypes.buyAndGetCombo.offerApplicableAt">
                        <div>{{ $t("boxoffice") }}</div>
                      </b-form-radio>
                    </div>
                  </div>
                  <div class="col-12" v-if="
                    offerTypes.buyAndGetCombo.offerApplicableAt === 'fAndb'
                  ">
                    <div class="row">
                      <div class="col-lg-12 col-xl-12 pl-0">
                        <div class="row mx-0 align-items-center">
                          <div class="mb-0">
                            <span class="text-nowrap">{{ $t("buy") }}</span>
                          </div>
                          <div class="input-material-sm mx-1">
                            <input v-model="offerTypes.buyAndGetCombo.F_And_B
                              .oc_buy_item_count
                              " type="text" name="buy_fnb_combo" id="buy_fnb_combo" v-validate="'required|numeric'" />
                          </div>

                          <div class="col-2">
                            <div class="dropdown-curve-container">
                              <label :class="offerTypes.buyAndGetCombo.F_And_B.selectedBuyFnbItem.hasOwnProperty(
                                'item_id'
                              )
                                ? 'shift-up'
                                : 'font-weight-bold'
                                ">{{ $tc("fnbitems") }}</label>
                              <div>
                                <multiselect v-model="offerTypes.buyAndGetCombo.F_And_B
                                  .selectedBuyFnbItem
                                  " :options="masterData.fnbItems" :placeholder="$tc('fnbitems')" label="item_name"
                                  isSingleId="item_id" :multiple="false" track-by="item_id"></multiselect>
                              </div>
                            </div>
                          </div>
                          <span class="text-nowrap">{{ $t("get") }}</span>

                          <div class="input-material-sm mx-2">
                            <input style="text-align: right" v-model="offerTypes.buyAndGetCombo.F_And_B
                              .oc_get_item_count
                              " type="text" name="get_fnb_combo" id="get_fnb_combo" v-validate="'required|numeric'" />
                          </div>
                          <div class="col-2">
                            <div class="dropdown-curve-container">
                              <label :class="offerTypes.buyAndGetCombo.F_And_B.selectedGetFnbItem.hasOwnProperty(
                                'item_id'
                              )
                                ? 'shift-up'
                                : 'font-weight-bold'
                                ">{{ $tc("fnbitems") }}</label>
                              <div>
                                <multiselect v-model="offerTypes.buyAndGetCombo.F_And_B
                                  .selectedGetFnbItem
                                  " :options="masterData.fnbItems" :placeholder="$tc('fnbitems')" label="item_name"
                                  isSingleId="item_id" :multiple="false" track-by="item_id"></multiselect>
                              </div>
                            </div>
                          </div>
                          <div class="d-flex align-items-center">
                            <b-form-checkbox class="j-checkbox pb-0 ml-3" v-model="offerTypes.buyAndGetCombo.F_And_B
                              .oc_is_combo_free
                              " unchecked-value="N" value="Y"></b-form-checkbox>
                            <span class="text-nowrap">Free</span>
                          </div>

                          <div v-if="
                            offerTypes.buyAndGetCombo.F_And_B
                              .oc_is_combo_free === 'N'
                          " style="display: flex">
                            <div class="d-flex align-items-center ml-3">
                              <span class="text-nowrap">&nbsp;{{ $t("offer") }} {{ $t("value") }}</span>
                              <div class="input-material-sm mx-2">
                                <input style="text-align: right" type="text" name="free_combo_offer_value"
                                  id="free_combo_offer_value" v-validate="'required|decimal'" v-model="offerTypes.buyAndGetCombo.F_And_B
                                    .oc_discount_value
                                    " />
                              </div>
                            </div>
                            <div class="d-flex align-items-center">
                              <b-form-checkbox class="j-checkbox pb-0 ml-3" v-model="offerTypes.buyAndGetCombo.F_And_B
                                .oc_discount_value_is_percentage
                                " unchecked-value="N" value="Y"></b-form-checkbox>
                              {{ $t("Percentage") }}
                            </div>
                          </div>
                        </div>
                        <p v-if="
                          (submit.offer_types &&
                            errors.has('buy_fnb_combo')) ||
                          errors.has('get_fnb_combo') ||
                          (offerTypes.buyAndGetCombo.F_And_B
                            .oc_is_combo_free === 'N' &&
                            errors.has('free_combo_offer_value'))
                        " class="error_message">
                          <span>{{
                            errors.first("buy_fnb_combo") ||
                            errors.first("get_fnb_combo") ||
                            errors.first("free_combo_offer_value")
                          }}</span>
                        </p>
                        <p v-else-if="
                          submit.offer_types &&
                          offerTypes.buyAndGetCombo.F_And_B
                            .oc_buy_item_count != null &&
                          offerTypes.buyAndGetCombo.F_And_B
                            .oc_buy_item_id == null
                        " class="error_message">
                          <span>Please select F&B item for Buy.</span>
                        </p>
                        <p v-else-if="
                          submit.offer_types &&
                          offerTypes.buyAndGetCombo.F_And_B
                            .oc_get_item_count != null &&
                          offerTypes.buyAndGetCombo.F_And_B
                            .oc_get_item_id == null
                        " class="error_message">
                          <span>Please select F&B item for Get.</span>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="col-12" v-if="
                    offerTypes.buyAndGetCombo.offerApplicableAt ===
                    'boxOffice'
                  ">
                    <div class="row">
                      <div class="col-lg-12 col-xl-12 pl-0">
                        <div class="row mx-0 align-items-center">
                          <div>
                            <span class="text-nowrap">{{ $t("buy") }}</span>
                          </div>
                          <div class="input-material-sm mx-1">
                            <input style="text-align: right" v-model="offerTypes.buyAndGetCombo.boxOffice
                              .oc_buy_no_of_ticket
                              " type="text" name="buy_bo_combo" id="buy_bo_combo" v-validate="'required|numeric'" />
                          </div>

                          <span class="text-nowrap">{{ $t("tickets") }}&nbsp;{{ $t("get") }}</span>

                          <div class="col-2">
                            <div class="dropdown-curve-container">
                              <label :class="offerTypes.buyAndGetCombo.boxOffice.selectedGetFnbItem.hasOwnProperty(
                                'item_id'
                              )
                                ? 'shift-up'
                                : 'font-weight-bold'
                                ">{{ $tc("fnbitems") }}</label>
                              <div>
                                <multiselect v-model="offerTypes.buyAndGetCombo.boxOffice
                                  .selectedGetFnbItem
                                  " :options="masterData.fnbItems" :placeholder="$tc('fnbitems')" label="item_name"
                                  isSingleId="item_id" :multiple="false" track-by="item_id"></multiselect>
                              </div>
                            </div>
                          </div>

                          <div class="d-flex align-items-center" style="">
                            <b-form-checkbox class="j-checkbox pb-0 ml-1" v-model="offerTypes.buyAndGetCombo.boxOffice
                              .oc_is_combo_free
                              " unchecked-value="N" value="Y"></b-form-checkbox>

                            <span class="text-nowrap">{{ $t("free") }}</span>
                          </div>
                          <div v-if="
                            offerTypes.buyAndGetCombo.boxOffice
                              .oc_is_combo_free === 'N'
                          " style="display: flex">
                            <div class="d-flex align-items-center ml-5">
                              <span class="text-nowrap">&nbsp;{{ $t("offer") }} {{ $t("value") }}</span>
                              <div class="input-material-sm mx-2">
                                <input style="text-align: right" type="text" name="free_combo_bo_offer_value"
                                  id="free_combo_bo_offer_value" v-validate="'required|decimal'" v-model="offerTypes.buyAndGetCombo.boxOffice
                                    .oc_discount_value
                                    " />
                              </div>
                            </div>
                            <div class="d-flex align-items-center">
                              <b-form-checkbox class="j-checkbox pb-0 ml-3" v-model="offerTypes.buyAndGetCombo.boxOffice
                                .oc_discount_value_is_percentage
                                " unchecked-value="N" value="Y" switch></b-form-checkbox>
                              {{ $t("isPercentage") }}
                            </div>
                          </div>
                        </div>
                        <p v-if="
                          (submit.offer_types &&
                            errors.has('buy_bo_combo')) ||
                          (offerTypes.buyAndGetCombo.boxOffice
                            .oc_is_combo_free === 'N' &&
                            errors.has('free_combo_bo_offer_value'))
                        " class="error_message">
                          <span>{{
                            errors.first("buy_bo_combo") ||
                            errors.first("free_combo_bo_offer_value")
                          }}</span>
                        </p>
                        <p v-else-if="
                          submit.offer_types &&
                          offerTypes.buyAndGetCombo.boxOffice
                            .oc_buy_no_of_ticket != null &&
                          offerTypes.buyAndGetCombo.boxOffice
                            .oc_get_item_id == null
                        " class="error_message">
                          <span>Please select F&B item for get.</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!--Fixed Price Ticket And FNB-->
              <div class="offer-content-wrapper py-0 pl-0" v-if="offerTypes.selectedOfferType == 'fixedPriceTicketFnb'">
                <div class="row section-border px-2 py-3 mx-1 mt-3">
                  <div class="col-lg-12 col-xl-12">
                    <div class="row mx-0 align-items-center">
                      <div>
                        <span class="text-nowrap">{{ $t("buy") }}</span>
                      </div>
                      <div class="input-material-sm mx-1">
                        <input style="text-align: right" v-model="offerTypes.buyTicketFnbFixedPrice
                          .oc_buy_no_of_ticket
                          " type="text" name="buy_fixed_price_ticket_count" id="buy_fixed_price_ticket_count"
                          v-validate="'required'" />
                      </div>

                      <span class="text-nowrap">{{ $t("tickets") }}</span>

                      <div style="display: flex">
                        <div class="d-flex align-items-center ml-2">
                          <span class="text-nowrap">{{ $t("atFlatRate") }}&nbsp;</span>
                          <div class="input-material-sm mx-2">
                            <input style="text-align: right" type="text" name="fixedPrice_bo_offer_value"
                              id="fixedPrice_bo_offer_value" v-validate="'required'" v-model="offerTypes.buyTicketFnbFixedPrice
                                .oc_discount_value
                                " />
                          </div>
                          <span class="text-nowrap">{{ $t("Each") }}</span>
                        </div>
                      </div>

                      <div class="d-flex align-items-center">
                        <b-form-checkbox class="j-checkbox pb-0 ml-5" id="combineFixedTicketFnb"
                          name="combineFixedTicketFnb" v-model="offerTypes.buyTicketFnbFixedPrice
                            .oc_is_combo_with_fnb
                            " unchecked-value="N" value="Y">
                        </b-form-checkbox>
                        <label class="mt-2" for="combineFixedTicketFnb">
                          {{ $t("combinewithfnb") }}</label>
                      </div>

                      <div style="display: flex">
                        <div class="d-flex align-items-center ml-5">
                          <span class="text-nowrap">{{ "Max Ticket Limit" }}&nbsp;</span>
                          <div class="input-material-sm mx-2">
                            <input style="text-align: right" type="text" name="mx_count_ticket" id="mx_count_ticket"
                              v-model="offerTypes.buyTicketFnbFixedPrice
                                .oc_max_no_of_ticket_per_transaction
                                " />
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- SHOW ERROR HERE -->
                  </div>

                  <div class="col-lg-12 col-xl-12 pl-0 mt-3" v-if="
                    offerTypes.buyTicketFnbFixedPrice.oc_is_combo_with_fnb ==
                    'Y'
                  ">
                    <div class="row mx-0 align-items-center mb-3" v-for="(fnbCombo, fnbComboIndex) in offerTypes
                      .buyTicketFnbFixedPrice.fnb_group_data" :key="fnbComboIndex">
                      <div class="col-md-1">
                        <div class="d-flex align-items-center justify-content-between">
                          <div>
                            <span class="text-nowrap">{{ $t("buy") }}</span>
                          </div>
                          <div class="input-material-sm mx-1">
                            <input style="text-align: right" v-model="fnbCombo.oc_buy_no_of_item" type="text"
                              name="buy_fixedprice_item" id="buy_fixedprice_item" v-validate="'required'" />
                          </div>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <div class="">
                          <multiselect v-model="fnbCombo.selectedFnbItem" @select="
                            selectFnbItemFixedOffer(
                              $event,
                              fnbComboIndex,
                              'Add'
                            )
                            " @remove="
                              selectFnbItemFixedOffer(
                                $event,
                                fnbComboIndex,
                                'Remove'
                              )
                              " :options="masterData.fnbItems" :placeholder="$tc('fnbitems')" label="item_name"
                            isSingleId="item_id" :multiple="false" track-by="item_id"></multiselect>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <div style="display: flex">
                          <div class="d-flex align-items-center">
                            <span class="text-nowrap">{{ $t("atFlatRate") }}&nbsp;</span>
                            <div class="input-material-sm mx-2">
                              <input style="text-align: right" type="text" name="fixed_fnb_bo_offer_value"
                                id="fixed_fnb_bo_offer_value" v-validate="'required'"
                                v-model="fnbCombo.oc_fnb_at_price" />
                            </div>
                            <span class="text-nowrap">{{ $t("Each") }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="d-flex justify-content-center align-items-center">
                          <button class="btn-transparent" @click="addFnbCriteria()" v-if="fnbComboIndex == 0">
                            <img src="@/assets/img/icons/plus.svg" height="29" width="29" />
                          </button>
                          <button v-if="fnbComboIndex !== 0" class="btn-transparent"
                            @click="removeFnbCriteria(fnbComboIndex)">
                            <img src="@/assets/img/icons/minus.svg" height="29" width="29" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- SHOW ERROR HERE -->
                  </div>
                </div>
              </div>

              <!--Buy 1 get Off on Another Ticket-->
              <div class="offer-content-wrapper py-0 pl-0"
                v-if="offerTypes.selectedOfferType == 'buyAndgetOffOnAnother'">
                <div class="row section-border px-2 py-3 mx-1 mt-3">
                  <div class="col-lg-12 col-xl-12">
                    <div class="row d-flex mx-0 align-items-center" style="gap: 35px">
                      <div class="align-self-center mb-2">
                        <div class="d-flex align-items-center">
                          {{ $t("buy") }}
                          <div class="input-material-sm mx-1">
                            <input style="text-align: right" name="discount_buy_value" id="discount_buy_value"
                              v-validate="'required|numeric'" type="text" v-model="offerTypes.buyAndgetOffOnAnother
                                .oc_buy_no_of_ticket
                                " />
                          </div>
                          {{ $t("buyAndgetOffOnAnother_des") }}
                          <div class="input-material-sm mx-2">
                            <input style="text-align: right" type="text" name="discount_get_value"
                              id="discount_get_value" v-validate="'required|numeric'" v-model="offerTypes.buyAndgetOffOnAnother
                                .oc_discount_value
                                " />
                          </div>
                          <span v-if="
                            offerTypes.buyAndgetOffOnAnother
                              .oc_discount_value_is_percentage == 'Y'
                          ">{{ "%" }}</span>
                          <span v-else>{{ "Flat" }}</span>
                          &nbsp;
                          {{ $t("buyAndgetOffOnAnother_des2") }}
                        </div>
                        <p v-if="
                          (submit.offer_types &&
                            errors.has('discount_buy_value')) ||
                          (submit.offer_types &&
                            errors.has('discount_get_value'))
                        " class="error_message">
                          <span>{{
                            errors.first("discount_buy_value") ||
                            errors.first("discount_get_value")
                          }}</span>
                        </p>
                      </div>
                      <div class="align-self-center mb-2">
                        <div class="d-flex align-items-center">
                          <b-form-checkbox class="j-checkbox pb-0" v-model="offerTypes.buyAndgetOffOnAnother
                            .oc_discount_value_is_percentage
                            " unchecked-value="N" value="Y"></b-form-checkbox>
                          {{ $t("Percentage") }}
                        </div>
                      </div>

                      <div class="align-self-center mb-lg-2 mb-xl-2">
                        <div class="d-flex align-items-center">
                          {{ "Max Ticket Limit" }}
                          <div class="input-material-sm mx-2">
                            <input style="text-align: right" type="text" name="max_discount_per_trans"
                              id="max_discount_per_trans" v-model="offerTypes.buyAndgetOffOnAnother
                                .oc_max_no_of_ticket_per_transaction
                                " />
                          </div>
                        </div>
                      </div>

                      <div class="d-flex  align-items-center align-self-center mb-lg-2 mb-xl-2">
                        <div class="mx-2 ">
                          <b-form-radio value="N" class="j-radio" v-model="offerTypes.buyAndgetOffOnAnother
                            .oc_offer_on_higher_amount
                            ">
                            <div>{{ "Lower Price" }}</div>
                          </b-form-radio>
                        </div>
                        <div class="mx-2 ">
                          <b-form-radio value="Y" class="j-radio" v-model="offerTypes.buyAndgetOffOnAnother
                            .oc_offer_on_higher_amount
                            ">
                            <div>{{ "Higher Price" }}</div>
                          </b-form-radio>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Fnb Item Discounts -->
              <div class="offer-content-wrapper section-border mt-3 p-3"
                v-if="offerTypes.selectedOfferType == 'fnbItemDiscounts'">
                <div class="row p-0 m-0">
                  <div class="col-7 p-0">
                    <table class="swc-report-table" border="1" style="table-layout: auto; background: white; zoom: 0.9">
                      <thead>
                        <tr class="bg-lightprimary ">
                          <th class="bg-lightprimary p-1" style="width: 900px">
                            Fnb Items<span class="required_star">*</span>
                          </th>
                          <th class="bg-lightprimary p-1" style="width: 150px">
                            Discounts (%)<span class="required_star">*</span>
                          </th>
                          <th style="width: 10px"></th>
                        </tr>
                      </thead>
                      <tbody v-if="
                        offerTypes.fnbItemDiscounts &&
                        offerTypes.fnbItemDiscounts.length > 0
                      ">
                        <template v-for="(fnbItemObj,
                          fnbItemIndexObj) in offerTypes.fnbItemDiscounts">
                          <tr :key="fnbItemIndexObj">
                            <td class="text-left p-0 manual_bill_item">
                              <div class="dropdown-curve-container">
                                <label v-if="
                                  !fnbItemObj.selectedFnbItem ||
                                  !fnbItemObj.selectedFnbItem.length
                                " :class="fnbItemObj.selectedFnbItem &&
                                  fnbItemObj.selectedFnbItem.length
                                  ? 'shift-up'
                                  : 'font-weight-bold'
                                  ">{{ $tc("fnbitems") }}</label>

                                <div>
                                  <multiselect :value="fnbItemObj.selectedFnbItem" :options="fnbItemsForFnbDiscount"
                                    placeholder="" group-values="fnbItemsData" group-label="fc_name" label="item_name"
                                    :group-select="true" isSingleId="item_code" :multiple="true" :searchable="true"
                                    :closeOnSelect="false" :limit="2" :limit-text="(count) => `& +${count} More`"
                                    track-by="item_code" @select="
                                      updateFnbList(
                                        fnbItemIndexObj,
                                        $event,
                                        'add'
                                      )
                                      " @remove="
                                        updateFnbList(
                                          fnbItemIndexObj,
                                          $event,
                                          'remove'
                                        )
                                        "></multiselect>
                                </div>
                              </div>
                            </td>
                            <td class="text-left p-0 manual_bill_item">
                              <div class="manual_bill_input">
                                <input v-model="fnbItemObj.pv_fnb_item_offer" placeholder="Discount" type="number"
                                  @input="
                                    updateSendPayload($event, fnbItemIndexObj)
                                    " class="text-right" />
                              </div>
                            </td>
                            <td>
                              <button @click.prevent.stop="
                                removeFnbItemDiscountRow(fnbItemIndexObj)
                                " class="btn-transparent">
                                <img src="@/assets/img/icons/minus.svg" height="20" width="20" />
                              </button>
                            </td>
                          </tr>
                        </template>
                        <tr class="">
                          <td colspan="12">
                            <div class="row d-flex align-items-center justify-content-center   position-relative">
                              <button @click.prevent.stop="addFnbItemDiscountRow()" class="btn-transparent">
                                <img src="@/assets/img/icons/plus.svg" height="20" width="20" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-if="
                        !offerTypes.fnbItemDiscounts ||
                        !offerTypes.fnbItemDiscounts.length
                      ">
                        <tr class="">
                          <td colspan="12">
                            <div class="row d-flex align-items-center justify-content-center   position-relative">
                              <button @click.prevent.stop="addFnbItemDiscountRow()" class="btn-transparent">
                                <img src="@/assets/img/icons/plus.svg" height="20" width="20" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- Free Tickets -->
              <div class="offer-content-wrapper section-border mt-3 p-2"
                v-if="offerTypes.selectedOfferType == 'freeTickets'">
                <div class="row p-1">
                  <div class="col-4">
                    <div class="input-material">
                      <input v-model="offerTypes.freeTickets.freeTicketCount" placeholder="" type="number" />
                      <label>Free Tickets</label>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="d-flex align-items-center">
                      <b-form-checkbox @input="handleFreeMaxTicket($event)" unchecked-value="N" value="Y"
                        v-model="offerTypes.freeTickets.isMaxFreeeTicketCount"
                        class="j-checkbox pb-0"></b-form-checkbox>
                      <div class="ml-2">Is max ticket limit</div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="input-material">
                      <input v-model="offerTypes.freeTickets.maxDiscountAmount" placeholder="" type="number" />
                      <label>Max. Ticket Value</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-1 d-flex justify-content-end align-items-end">
              <div class="icon-save-btn blue-icon mx-1 btn float-right" :title="'Save'" @click="updateOfferCriteria">
              </div>
            </div>
          </div>
        </div>
        <!-- </b-collapse> -->
      </section>

      <!-- redemption outlet -->
      <section class="my-2">
        <div class="section-border container  rounded-10 col-12 py-3 mb-2">
          <h5 class="heading">Redemption Outlet</h5>

          <div class="row align-items-center mt-3">
            <div class="col-12 col-md-12 col-lg-2 col-xl-2 my-2 ">
              <div class="dropdown-curve-container">
                <label :class="redemptionOutletData.selectedUsers.length > 0
                  ? 'shift-up'
                  : 'font-weight-bold'
                  ">
                  {{ $tc("Sales Channel") }}
                </label>
                <multiselect v-model="redemptionOutletData.selectedUsers" :options="masterData.userList"
                  :close-on-select="false" placeholder="" label="user_name" :multiple="true" track-by="user_id">
                </multiselect>
              </div>
            </div>

            <!-- <div class="col-lg-2 col-xl-2 align-self-center">
              <div class="d-flex align-items-center">
                <b-form-checkbox :disabled="offerTypes.is_employee_offer == 'Y'"
                  v-model="redemptionOutletData.offer_redeem_at_online" unchecked-value="N" value="Y"
                  class="j-checkbox pb-0"></b-form-checkbox>
                <div class="ml-2">{{ $t("canavailonline") }}</div>
              </div>
            </div> -->

            <div class="col-6 col-lg-2 col-xl-2  my-2 align-self-center">
              <div class="d-flex align-items-center">
                <b-form-checkbox :disabled="['fnbItemDiscounts'].includes(offerTypes.selectedOfferType)
                  " v-model="redemptionOutletData.offer_redeem_at_boxoffice" unchecked-value="N" value="Y"
                  class="j-checkbox pb-0"></b-form-checkbox>
                <div class="ml-2">Avail on Ticket</div>
              </div>
            </div>

            <div class=" col-6 col-lg-3 col-xl-3  my-2 align-self-center">
              <div class="d-flex align-items-center">
                <b-form-checkbox :disabled="[
                  'buyAndGetFreeTickets',
                  'fixedPriceTicketFnb',
                  'buyAndgetOffOnAnother',
                  'fnbItemDiscounts',
                ].includes(offerTypes.selectedOfferType)
                  " v-model="redemptionOutletData.offer_redeem_at_concession" unchecked-value="N" value="Y"
                  class="j-checkbox pb-0"></b-form-checkbox>
                <div class="ml-2 d-flex">
                  Avail on FnB<br />
                  <span class="text-muted fs-12">
                    {{
                      [
                        "buyAndGetFreeTickets",
                        "fixedPriceTicketFnb",
                        "buyAndgetOffOnAnother",
                      ].includes(offerTypes.selectedOfferType)
                        ? "(Not Applicable)"
                        : ""
                    }}
                  </span>
                </div>
              </div>
            </div>
            <div v-if="isEpix" class="col-12 col-md-4 col-lg-4 my-2">
              <div class="d-flex align-items-center">
                <b-form-radio value="gross" class="j-radio" v-model="redemptionOutletData.offer_applicable_on"
                  @change="handleRadioChange($event)">
                  <div>
                    <span>{{ $tc("ApplicableOnGrossAmount") }}</span>
                  </div>
                </b-form-radio>
                <strong class="mx-3">OR</strong>

                <b-form-radio value="net" class="j-radio" v-model="redemptionOutletData.offer_applicable_on"
                  @change="handleRadioChange($event)">
                  <div>
                    <span>{{ $tc("ApplicableOnNetAmount") }}</span>
                  </div>
                </b-form-radio>
              </div>
            </div>

            <div class="col-12 d-flex justify-content-end ">
              <div class="icon-save-btn blue-icon mx-1 btn float-right" :title="'Save'" @click="updateRedemptionOutlet">
              </div>
            </div>
          </div>
        </div>
      </section>

      <!---dstributor report sectiion-->
      <section class="my-2">
        <div class="section-border  container rounded-10 col-12 py-3 px-2 mb-2 ">
          <h5 class="heading">Distributor Reporting Values</h5>
          <template v-if="distributorSection.distributorData.length">
            <div class="row greyBackground my-2  px-2 py-2 mx-2 " v-for="(settingsObj,
              settingsIndex) in distributorSection.distributorData" :key="settingsIndex">
              <div class="col-11">
                <div class=" row bg-white">
                  <!-- <div class="col-12  col-lg-2 my-2">
                    <div class="dropdown-curve-container">
                      <label :class="settingsObj.selectedCinema &&
                        settingsObj.selectedCinema.cine_name
                        ? 'shift-up'
                        : 'font-weight-bold'
                        ">{{ $t("select") }} {{ $tc("cinema", 1) }}</label>
                      <multiselect v-model="settingsObj.selectedCinema" :options="masterData.cinemasList"
                        open-direction="bottom" :placeholder="$tc('Cinemas')" label="cine_name" track-by="cine_id"
                        @input="makeUpdatedDistributorShareSectionData(settingsIndex, 'cinema', '', $event)">
                      </multiselect>
                    </div>
                  </div> -->
                  <div class="col-12 col-lg-3 my-2">
                    <div class="dropdown-curve-container">
                      <label :class="settingsObj.selectedSeatTypes.length
                        ? 'shift-up'
                        : 'font-weight-bold'
                        ">{{ $t("select") }} Seat Types</label>
                      <multiselect v-model="settingsObj.selectedSeatTypes" :options="masterData.seatGroups"
                        open-direction="bottom" :close-on-select="false" placeholder="Seat Groups" label="sstg_name"
                        track-by="sstg_id" :multiple="true" @input="
                          makeUpdatedDistributorShareSectionData(
                            settingsIndex,
                            'seatTypes',
                            'add'
                          )
                          " @remove="
                            makeUpdatedDistributorShareSectionData(
                              settingsIndex,
                              'seatTypes',
                              'remove'
                            )
                            ">
                      </multiselect>
                    </div>
                  </div>
                  <div class="col-12 col-lg-3 my-2">
                    <div class="dropdown-curve-container">
                      <label :class="settingsObj.selectedTickets.length
                        ? 'shift-up'
                        : 'font-weight-bold'
                        ">{{ $t("select") }} Ticket Types</label>
                      <multiselect v-model="settingsObj.selectedTickets" :options="masterData.ticketTypesData"
                        open-direction="bottom" :close-on-select="false" placeholder="Tickets" label="tt_name"
                        track-by="tt_id" :multiple="true" @input="
                          makeUpdatedDistributorShareSectionData(
                            settingsIndex,
                            'ticketTypes',
                            'add'
                          )
                          " @remove="
                            makeUpdatedDistributorShareSectionData(
                              settingsIndex,
                              'ticketTypes',
                              'remove'
                            )
                            ">
                      </multiselect>
                    </div>
                  </div>
                  <div class="col-3  d-flex align-items-center">
                    <div class="input-material">
                      <input v-model="settingsObj.pvds_dist_value" placeholder="" type="number" @input="
                        makeUpdatedDistributorShareSectionData(
                          settingsIndex,
                          'shareValue',
                          '',
                          $event
                        )
                        " />
                      <label>Dist.Value</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-1 greyBackground rounded-0 d-flex justify-content-center align-items-center">
                <button class="btn-transparent " @click="handleDistributorRowAction('remove', settingsIndex)">
                  <img src="@/assets/img/icons/minus.svg" height="30" width="30" />
                </button>
              </div>
            </div>
          </template>
          <div class="row  px-4 justify-content-between">
            <div class="col-6 d-flex justify-content-end">
              <button class="btn-transparent mb-3" @click="handleDistributorRowAction('add')">
                <img src="@/assets/img/icons/plus.svg" height="30" width="30" />
              </button>
            </div>
            <div class="col-6 d-flex pr-4 justify-content-end">
              <div class="icon-save-btn blue-icon mx-1 btn float-right" :title="'Save'"
                @click="updateDistributorSection">
              </div>
            </div>
          </div>
        </div>

        <!-- </b-collapse> -->
      </section>
      <div class="row d-flex justify-content-center pr-5">
        <div class="col-4 "></div>
        <div class="col-4 d-flex justify-content-center">
          <button @click="onFinalSubmit" class="btn-blue mr-3">Save</button>
        </div>
        <div class="col-4"></div>
      </div>
    </div>
    <ImageGallery v-bind:propImageName="'Offer Image'" v-bind:openModal="offerContent.showModal"
      v-bind:set_height="offerContent.set_height" v-bind:set_width="offerContent.set_width" :showPercentageLoader="true"
      :img_desc="'Offer Image'" :resetImgData="false" :category="'Offer Image'"></ImageGallery>
  </div>
</template>
<script>
import { generateRandomCode } from "@/helper/collection";
import MasterService from "@/services/MasterService";
import MovieService from "@/services/MovieService";
import moment from "moment";
import PosFnBService from "@/services/Pos_Fnb_Service";
import MarketingService from "@/services/MarketingService";
import ClientService from "@/services/ClientService";
import DatePicker from "vue2-datepicker";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import { VueEditor } from "vue2-editor";
import ImageGallery from "../../ImageGallery/imageGalleryModal";
import { mapGetters } from "vuex";
import { BASEURL } from "@/config/index";
import { CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";
import _ from "lodash";

let Start_Date = moment(
  `${moment()
    .subtract(1, "days")
    .format("YYYY-MM-DD")} 24:00:00`
).format();
let End_date = moment(`${moment().format("YYYY-MM-DD")} 23:59:59`).format();

export default {
  components: { DatePicker, VueTimepicker, VueEditor, ImageGallery },
  data() {
    return {
      offerSelected: true,
      voucherSelected: false,
      os_is_voucher: "N",
      titleName: "Offer",
      submit: {
        offer: false,
        offer_content: false,
        offer_movie: false,
        offer_days: false,
        offet_split: false,
        other_setting: false,
        offer_types: false,
        redemption_outlet: false,
      },
      //Collapse
      sectionCollapse: {
        offer: true,
        offer_content: false,
        cinema_configuration: false,
        movie_configuration: false,
        day_configuration: false,
        split_configuration: false,
        other_setting: false,
        offer_type: false,
        outlet: false,
        distributor_reporting: false,
      },
      selectedOfferGroupType: {},
      offer_id: null,
      offer: {
        os_is_active: "Y",
        offer_title: "",
        offer_code: generateRandomCode(8),
        offer_start_date_time: Start_Date,
        offer_end_date_time: End_date,
        offer_start_time: "06.00",
        offer_end_time: "05.59",
        offer_group_type_id: 1,
        offer_description_text: "",
        is_offer_auth_required: "N",
        visible_on_web: "N",
        is_redemption: "N",
        selectedOfferGroupType: {},
        is_package_offer: "N",
        report_offer: "N",
      },

      offerContent: {
        offerContentArray: [],
        pg_promo_code: [],
        activeIndex: 0,
        notempty: [false, false, false, false, false, false],
        uploadImageSType: "",
        bannerUpload: false,
        set_height: null,
        set_width: null,
        uploadIndex: null,
        showModal: null,
        isEdit: true,
        isEditHtml: false,
        banner_image_height: "690",
        banner_image_width: "2400",
        poster_image_height: "400",
        poster_image_width: "400",
      },
      check: [],
      voucherSettting: {
        oc_redemptions_per_patron: null,
        oc_total_redemptions: null,
      },
      offerMovieConfiguration: {
        os_is_foreign_movie_applicable: "N",
        os_movie_mf_id: "",
        os_is_movie_applicable: "Y",
        selectedMovieFormats: [],
        selectedParticaularMovies: [],
        movies_applicable_status: "movies_applicable",
        start_show_time: "",
        end_show_time: "",
        os_time_limit_start: null,
        os_time_limit_end: null
      },

      offerDaysConfiguration: {
        offer_applicable_on_all_day: "Y",
        TrueFalseCount: null,
        weekDays: {
          selectAll: "Y",
          sunday: "Y",
          monday: "Y",
          tuesday: "Y",
          wednesday: "Y",
          thursday: "Y",
          friday: "Y",
          saturday: "Y",
        },
      },
      offerSplitConfiguration: {
        client_share_value: null,
        client_share_is_percentage: "Y",
        offer_dist_share_threshold: null,
        selectedClient: {},
      },
      offerSettingConfiguration: {
        is_bank_offer: "N",
        selectedOfferType: "fixedDiscount",
        selectedCard: [],
        bankDetails: {
          selectedBank: "",
          bank_id: null,
          card_type_ids: null,
          boc_id: null,
        },
        report_full_amount: "N",
        report_full_amount_special_rc: "N",
        has_o_reporting_percent: "N",
        o_reporting_percent: null,
        clientShareSettings: {
          client: null,
          client_share_value: 0,
          is_share_percentage: "Y",
          is_prepaid_voucher: "N",
        },
      },
      offerTypes: {
        selectedOfferType: "fixedDiscount",
        is_employee_offer: "N",
        freeTickets: {
          freeTicketCount: null,
          maxFreeeTicketCount: null,
          maxDiscountAmount: 0,
        },
        discountLists: [
          {
            oc_buy_no_of_ticket: "",
            oc_discount_value: "",
            oc_discount_value_is_percentage: "N",
            oc_max_discount_amount: null,
            oc_min_ticket_price: 0,
            oc_min_fnb_price: 0,
            min_amount_channel_wise: "N",
          },
        ],
        fixedDiscount: {
          oc_buy_no_of_ticket: null,
          oc_discount_value: null,
          oc_discount_value_is_percentage: "N",
          oc_max_discount_amount: null,
          oc_min_ticket_price: null,
          oc_min_fnb_price: null,
          min_amount_channel_wise: "N",
        },
        buyAndGetFreeTickets: {
          oc_buy_no_of_ticket: null,
          oc_get_free_ticket: null,
          oc_min_ticket_price: null,
          oc_max_no_of_ticket_per_transaction: null,
          oc_combine_with_other_offers: "N",
        },
        discount: {
          oc_buy_no_of_ticket: null,
          oc_discount_value: null,
          oc_discount_value_is_percentage: "N",
          oc_max_discount_amount: null,
        },
        loyalityProgramOffer: {
          oc_buy_no_of_ticket: null,
          oc_discount_value: null,
          oc_discount_value_is_percentage: "N",
          oc_max_discount_amount: null,
        },
        buyAndGetCombo: {
          offerApplicableAt: "boxOffice",
          boxOffice: {
            oc_buy_no_of_ticket: null,
            oc_get_item_id: null,
            oc_is_combo_free: "N",
            oc_discount_value: null,
            oc_discount_value_is_percentage: "N",
            selectedGetFnbItem: {},
          },
          F_And_B: {
            oc_buy_item_count: null,
            oc_get_item_count: null,
            oc_buy_item_id: null,
            oc_get_item_id: null,
            // SelectedOnFnBItem: null,
            // SelectedFreeFnBItem: null,
            selectedBuyFnbItem: {},
            selectedGetFnbItem: {},
            oc_is_combo_free: "N",
            oc_discount_value_is_percentage: "N",
            oc_discount_value: null,
          },
        },
        buyTicketFnbFixedPrice: {
          oc_buy_no_of_ticket: null,
          // oc_ticket_at_price: null,
          oc_min_ticket_price: null,
          oc_discount_value: null,
          oc_discount_value_is_percentage: "N",
          oc_max_no_of_ticket_per_transaction: null,
          oc_is_combo_with_fnb: "N",
          fnb_group_data: [
            {
              oc_buy_no_of_item: null,
              oc_buy_item_id: null,
              oc_buy_item_code: null,
              selectedFnbItem: {},
              oc_fnb_at_price: null,
            },
          ],
        },
        buyAndgetOffOnAnother: {
          oc_buy_no_of_ticket: null,
          oc_discount_value: "",
          oc_discount_value_is_percentage: "Y",
          oc_offer_on_higher_amount: "N",
          oc_max_no_of_ticket_per_transaction: null,
        },

        fnbItemDiscounts: [
          {
            pv_fnb_item_code: "",
            pv_fnb_item_offer: null,
            selectedFnbItem: [],
            fnbItemForInactive: [],
          },
        ],
      },
      rejectedFnbItemCode: [],
      tempInactiveFnbItem: [],

      redemptionOutletData: {
        selectedUsers: [],
        offer_redeem_at_online: "Y",
        offer_redeem_at_boxoffice: "Y",
        offer_redeem_at_concession: "N",
        offer_applicable_on: "gross",
        offer_applicable_on_gross_amount: "Y",
        offer_applicable_on_net_amount: "N",
      },
      signageImageData: {
        signageContainer: [
          {
            height: 1920,
            width: 1080,
            imageUrl: "",
          },
          {
            height: 1080,
            width: 1920,
            imageUrl: "",
          },
        ],
        cropSizeEnable: false,
        _downloadImagePath: null,
        uploadIndex: null,
      },
      masterData: {
        offerGroupTypes: [],
        movieFormats: [],
        movieList: [],
        cinemasList: [],
        clientList: [],
        activeBankList: [],
        activeBankCardList: [],
        fnbItems: [],
        ContentLanguages: [],
        ticketTypesData: [],
        seatGroups: [],
        userList: [],
      },
      cinemaSettingsSection: {
        isCinemaSettingsApplicable: "N",
        allCinemaRowNotApplicableStatus: "Y",
        cinemaSettings: [],
        rejectedCinemaIds: [],
        availableCinemasList: [],
      },
      distributorSection: {
        distributorData: [],
      },
      sendPayload: {
        movieList: [],
        cinemaSettingsList: [],
        fnbDiscountdata: [],
        distributorShareData: [],
      },
      custom_errors: {
        only_cinema_error: "",
        weekday_errors: "",
        voucher_start_date_error: "",
      },
    };
  },
  watch: {
    finalImagePath(newVal) {
      if (this.offerContent.uploadImageType == 1) {
        this.offerContent.offerContentArray[
          this.offerContent.activeIndex
        ].offer_banner_image = newVal;
      }
      if (this.offerContent.uploadImageType == 3) {
        this.signageImageData.signageContainer[
          this.offerContent.uploadIndex
        ].imageUrl = newVal;
      }
      if (this.offerContent.uploadImageType == 2) {
        this.offerContent.offerContentArray[
          this.offerContent.activeIndex
        ].offer_poster_image = newVal;
      }
      this.$forceUpdate();
    },
    "sectionCollapse.distributor_reporting": function (newValue) {
      if (newValue === true && this.masterData.seatGroups.length === 0) {
        this.getSeatGroups();
        this.getTicketType();
      }
      if (
        newValue === true &&
        this.distributorSection.distributorData.length === 0
      ) {
        this.handleDistributorRowAction("add");
      }
    },
  },
  computed: {
    ...mapGetters(["finalImagePath"]),
    showGrossNetButton() {
      return CLIENT_NAMES_OBJ.EPIX.includes(String(this.CLIENT_SETUP_NAME));
    },
    showForeignMovieSection() {
      return CLIENT_NAMES_OBJ.showForeignMovieSection.includes(
        String(this.CLIENT_SETUP_NAME)
      );
    },
    isEpix() {
      return CLIENT_NAMES_OBJ.EPIX.includes(String(this.CLIENT_SETUP_NAME));
    },
    isReportingFeeClient() {
      return CLIENT_NAMES_OBJ.reportingFeeClient.includes(
        String(this.CLIENT_SETUP_NAME)
      );
    },
  },

  beforeMount() {
    let cinemaid =
      this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    let roleid = this.secureStore.get("USINFO").role_id;

    if (roleid == 3) {
      this.$router.go(-1);
    } else {
      const { os_id } = this.$route.query;
      if (os_id) {
        this.offer_id = os_id;
      } else {
        this.$router.go(-1);
      }
    }
    Promise.all([
      this.getMovieFormats(),
      this.getCinemasList(),
      this.getActiveMovies(),
      this.getClientList(),
      this.getBankList(),
      this.getFnBItems(),
      this.getUserList(),
      this.getContentLangauge(),
      this.getOfferGroupType(),
      this.getSeatGroups(),
      this.getTicketType(),
      this.getFnBItemsForFnbDiscountOfferType(),
    ]).then(() => {
      this.getOfferPromotionVoucherData();
    });
  },
  methods: {
    handleFreeMaxTicket(event) {
      if (!this.offerTypes.freeTickets.freeTicketCount)
        return this.$toasted.show("Enter number of free tickets first");
      if (event == "Y") {
        this.offerTypes.freeTickets.maxFreeeTicketCount = this.offerTypes.freeTickets.freeTicketCount;
      } else {
        this.offerTypes.freeTickets.maxFreeeTicketCount = null;
      }
    },
    uniqueCinemaList(cinemasData) {
      if (!cinemasData.length) return [];

      let resultCinemasArr = [];
      cinemasData.forEach((cinemasObj) => {
        let cinemaIndex = resultCinemasArr.findIndex((cinemasIndexObj) => {
          return cinemasIndexObj.cine_id == cinemasObj.cine_id;
        });

        if (cinemaIndex < 0) {
          resultCinemasArr.push(cinemasObj);
        }
      });
      return resultCinemasArr;
    },
    handleApplicableCinemaSettings(event) {
      if (event == "Y" && !this.cinemaSettingsSection.cinemaSettings.length) {
        this.cinemaSettingsSection.cinemaSettings.push({
          selectedCinema: [],
          allowedCinemaList: this.masterData.cinemasList,
          allowedScreenList: [],
          cinemaScreens: [],
          selectedScreens: [],
          selectedSeatTypes: [],
          selectedTickets: [],
          is_settings_applicable: "Y",
          pvcs_id: null,
        });
        this.cinemaSettingsSection.availableCinemasList = this.masterData.cinemasList.map(
          (cinemasObj) => {
            return { ...cinemasObj };
          }
        );
      } else {
        if (this.sendPayload.cinemaSettingsList.length) {
          this.sendPayload.cinemaSettingsList.forEach((cinemaObj) => {
            cinemaObj.pvcs_is_active = "N";
          });
        }
        this.cinemaSettingsSection.cinemaSettings = [];
      }
    },
    async handleCinemaSettings(type, index = null) {
      if (type === "add") {
        // let data = await this.getCinemaNewList();
        // if (!this.cinemaSettingsSection.availableCinemasList.length) {
        //   return this.$toasted.show("cinemas is not availble for next row");
        // }
        let isCinemasEmpty = this.cinemaSettingsSection.cinemaSettings.some(
          (selectedCinemaObj) => {
            return (
              !selectedCinemaObj.selectedCinema.length &&
              selectedCinemaObj.pvcs_is_active == "Y"
            );
          }
        );
        if (isCinemasEmpty)
          return this.$toasted.show("Cinema missing in row");
        let currentSelectedCinemas = this.cinemaSettingsSection.cinemaSettings.map(
          (cinemasObj) => {
            let cinemasData = cinemasObj.selectedCinema.map(
              (selectedCinemaObj) => {
                return String(selectedCinemaObj.cine_id);
              }
            );
            return cinemasData;
          }
        );
        let availableCinemasList = this.masterData.cinemasList.map(
          (cinemasObj) => {
            return { ...cinemasObj };
          }
        );
        if (currentSelectedCinemas.length) {
          let flatCurrentCinemas = currentSelectedCinemas.flatMap(
            (flatCinemasData) => {
              return flatCinemasData;
            }
          );
          availableCinemasList = this.masterData.cinemasList.filter(
            (cinemasObj) => {
              return !flatCurrentCinemas.includes(String(cinemasObj.cine_id));
            }
          );
        }
        if (!availableCinemasList.length) {
          return this.$toasted.show(`All cinema settings are added`);
        }
        this.cinemaSettingsSection.cinemaSettings.push({
          selectedCinema: [],
          cinemaScreens: [],
          allowedCinemaList: this.uniqueCinemaList(availableCinemasList),
          allowedScreenList: [],
          selectedScreens: [],
          selectedSeatTypes: [],
          selectedTickets: [],
          is_settings_applicable: this.cinemaSettingsSection
            .allCinemaRowNotApplicableStatus,
          pvcs_id: null,
          pvcs_is_active: "Y",
        });
      } else {
        this.cinemaSettingsSection.cinemaSettings[index].pvcs_is_active = "N";

        let cinemaDataRemovedRow = this.cinemaSettingsSection.cinemaSettings[
          index
        ].selectedCinema;

        this.cinemaSettingsSection.cinemaSettings.forEach((cinemasObj) => {
          if (cinemasObj.pvcs_is_active == "Y") {
            cinemasObj.allowedCinemaList = this.uniqueCinemaList([
              ...cinemasObj.allowedCinemaList,
              ...cinemaDataRemovedRow,
            ]);
          }
        });
        this.$forceUpdate();

        if (!this.cinemaSettingsSection.cinemaSettings.length) {
          this.cinemaSettingsSection.isCinemaSettingsApplicable = "N";
        }
      }
    },
    handleCinemaScreenChange(index, event) {
      // if (event[event.length-1].screen_id === "all") {
      //   this.cinemaSettingsSection.cinemaSettings[index].cinemaScreens = this.cinemaSettingsSection.cinemaSettings[index].cinemaScreens.map(screens => ({ ...screens, $isDisabled: true }))
      // }
    },
    removeSelectedCinemas(settingsIndex, event) {
      let pvcsIndex = -1;
      // if (this.cinemaSettingsSection.cinemaSettings[settingsIndex].pvcs_id) {
      //   pvcsIndex = this.sendPayload.cinemaSettingsList.findIndex(pvcsObj => pvcsObj.pvcs_id == this.cinemaSettingsSection.cinemaSettings[settingsIndex].pvcs_id)
      // }
      let updatedAvailableCinemas = this.masterData.cinemasList.filter(
        (filteredCinemasObj) => {
          return filteredCinemasObj.cine_id == event.cine_id;
        }
      );
      let updateAvailableScreens = this.cinemaSettingsSection.cinemaSettings[
        settingsIndex
      ].selectedScreens.filter((screensobj) => {
        return screensobj.cinema_id != event.cine_id;
      });
      console.log(event, updatedAvailableCinemas);
      // this.cinemaSettingsSection.availableCinemasList.push(event)
      this.cinemaSettingsSection.cinemaSettings.forEach(
        (cinemasObj, cinemaIndex) => {
          cinemasObj.allowedCinemaList = this.uniqueCinemaList([
            ...cinemasObj.allowedCinemaList,
            ...updatedAvailableCinemas,
          ]);
          if (settingsIndex == cinemaIndex) {
            cinemasObj.selectedScreens = [...updateAvailableScreens];
          }
        }
      );
      console.log(
        { event },
        "remove",
        this.cinemaSettingsSection.cinemaSettings
      );
      let currentSelectedCinemaList = this.cinemaSettingsSection.cinemaSettings[
        settingsIndex
      ].selectedCinema.filter((filterCinemasObj) => {
        return filterCinemasObj.cine_id != event.cine_id;
      });
      this.updateScreenListCinemaWise(
        currentSelectedCinemaList,
        settingsIndex
      );
    },
    makeUpdatedCinemaSettingsData(index, type, action = "", event) {
      if (
        type == "applicableKey" &&
        event == "N" &&
        this.cinemaSettingsSection.cinemaSettings[index]["selectedScreens"]
          .length > 0
      ) {
        this.cinemaSettingsSection.cinemaSettings[index][
          "selectedScreens"
        ] = [];
      }
      if (
        type == "applicableKey" &&
        event == "N" &&
        this.cinemaSettingsSection.cinemaSettings[index]["selectedSeatTypes"]
          .length > 0
      ) {
        this.cinemaSettingsSection.cinemaSettings[index][
          "selectedSeatTypes"
        ] = [];
      }
      let pvcsIndex = -1;
      if (this.cinemaSettingsSection.cinemaSettings[index].pvcs_id) {
        pvcsIndex = this.sendPayload.cinemaSettingsList.findIndex(
          (screenObj) =>
            screenObj.pvcs_id ==
            this.cinemaSettingsSection.cinemaSettings[index].pvcs_id
        );
      }

      if (type == "cinemas") {
        let cinemaDataList = this.cinemaSettingsSection.cinemaSettings[index]
          .selectedCinema.length
          ? this.cinemaSettingsSection.cinemaSettings[
            index
          ].selectedCinema.map((cinemaData) => String(cinemaData.cine_id))
          : [];

        if (pvcsIndex >= 0) {
          if (!cinemaDataList.length) {
            this.sendPayload.cinemaSettingsList[pvcsIndex].all_cinema_id = "";
            console.log("no cinema found, so returned empty");
            return;
          }
          this.sendPayload.cinemaSettingsList[
            pvcsIndex
          ].all_cinema_id = cinemaDataList.join(",");
        }

        this.cinemaSettingsSection.cinemaSettings.forEach((cinemasObj) => {
          cinemasObj.allowedCinemaList = this.uniqueCinemaList(
            cinemasObj.allowedCinemaList.filter((filteredCinemasObj) => {
              return event.cine_id != filteredCinemasObj.cine_id;
            })
          );
        });

        this.updateScreenListCinemaWise(
          [
            ...this.cinemaSettingsSection.cinemaSettings[index]
              .selectedCinema,
            event,
          ],
          index
        ); //this.cinemaSettingsSection.cinemaSettings[index].selectedCinema only get set after the function execution is completed. So used spread operator to add current object
      } else if (false && type == "screens" && pvcsIndex >= 0) {
        this.sendPayload.cinemaSettingsList[pvcsIndex].all_screen_ids = this
          .cinemaSettingsSection.cinemaSettings[index].selectedScreens.length
          ? this.cinemaSettingsSection.cinemaSettings[index].selectedScreens
            .map((screensData) => screensData.screen_id)
            .join(",")
          : "";
      } else if (false && type == "seatGroups" && pvcsIndex >= 0) {
        this.sendPayload.cinemaSettingsList[
          pvcsIndex
        ].all_seat_group_type_id = this.cinemaSettingsSection.cinemaSettings[
          index
        ].selectedSeatTypes.length
            ? this.cinemaSettingsSection.cinemaSettings[index].selectedSeatTypes
              .map((seatsData) => seatsData.sstg_id)
              .join(",")
            : "";
      } else if (false && type == "ticketTypes" && pvcsIndex >= 0) {
        this.sendPayload.cinemaSettingsList[pvcsIndex].all_tt_id = this
          .cinemaSettingsSection.cinemaSettings[index].selectedTickets.length
          ? this.cinemaSettingsSection.cinemaSettings[index].selectedTickets
            .map((ticketsData) => ticketsData.tt_id)
            .join(",")
          : "";
      } else if (false && type == "applicableKey" && pvcsIndex >= 0) {
        this.sendPayload.cinemaSettingsList[
          pvcsIndex
        ].is_settings_applicable = event;
      }
    },
    async updateCinemaSettingsSection() {
      if (this.cinemaSettingsSection.cinemaSettings.length) {
        this.sendPayload.cinemaSettingsList = [];
        console.log(this.cinemaSettingsSection.cinemaSettings);
        this.cinemaSettingsSection.cinemaSettings.forEach(
          (cinemaSettingObj) => {
            let cinemaSettingPayloadObj = {
              pvcs_id: cinemaSettingObj.pvcs_id
                ? cinemaSettingObj.pvcs_id
                : null,
              is_settings_applicable: cinemaSettingObj.is_settings_applicable,
              all_cinema_id: cinemaSettingObj.selectedCinema.length
                ? cinemaSettingObj.selectedCinema
                  .map((cinema) => cinema.cine_id)
                  .join(",")
                : "",
              all_screen_ids: cinemaSettingObj.selectedScreens.length
                ? cinemaSettingObj.selectedScreens
                  .map((screenObj) => screenObj.screen_id)
                  .join(",")
                : "",
              all_seat_group_type_id: cinemaSettingObj.selectedSeatTypes
                .length
                ? cinemaSettingObj.selectedSeatTypes
                  .map((seatObj) => seatObj.sstg_id)
                  .join(",")
                : "",
              all_tt_id: cinemaSettingObj.selectedTickets.length
                ? cinemaSettingObj.selectedTickets
                  .map((ticketObj) => ticketObj.tt_id)
                  .join(",")
                : "",
              pvcs_is_active: cinemaSettingObj.pvcs_is_active
                ? cinemaSettingObj.pvcs_is_active
                : "Y",
            };
            console.log({ cinemaSettingPayloadObj });

            if (
              (!cinemaSettingPayloadObj.pvcs_id &&
                cinemaSettingPayloadObj.pvcs_is_active == "N") ||
              (!cinemaSettingPayloadObj.pvcs_id &&
                !cinemaSettingPayloadObj.all_cinema_id)
            )
              return; //rows which were created in the current edit and removed will not be inserted
            this.sendPayload.cinemaSettingsList.push(cinemaSettingPayloadObj);
          }
        );
      }
      // return;
      const payload = {
        offersCinema: this.sendPayload.cinemaSettingsList.length
          ? this.sendPayload.cinemaSettingsList
          : [],
      };

      await this.onSubmit(payload, "offersCinemaSettingsSection");
      await this.getOfferPromotionVoucherData();
    },

    async getCinemaScreens(index, type = "setData", cinema_id = null) {
      try {
        const response = await MasterService.GetActiveList({
          tableName: "screens",
          screen_is_active: "Y",
          cinema_id: cinema_id
            ? cinema_id
            : this.cinemaSettingsSection.cinemaSettings[index].selectedCinema
              .cine_id,
        });
        const { data } = response;
        if (data.status && data.Records.length > 0 && index >= 0) {
          if (type == "setData") {
            this.cinemaSettingsSection.cinemaSettings[index][
              "cinemaScreens"
            ] = [{ screen_id: "all", screen_name: "All" }, ...data.Records];
          } else {
            return [
              { screen_id: "all", screen_name: "All" },
              ...data.Records,
            ];
          }
        } else {
          // Show Errors
          if (type != "setData") {
            return [];
          }
          console.log("show error:", data.message);
        }
      } catch (error) {
        this._CatchError(error);
      }
    },
    async getSeatGroups() {
      let loader;
      try {
        loader = this.$loading.show();
        const response = await MasterService.GetActiveList({
          tableName: "ms_screen_seat_type_group",
          sstg_is_active: "Y",
        });
        const { data } = response;
        if (data.status && data.Records.length > 0) {
          this.masterData.seatGroups = [...data.Records];
        } else {
          // Show Errors
          console.log("show error:", data.message);
        }
      } catch (error) {
        this._CatchError(error);
      } finally {
        if (loader) {
          loader.hide();
        }
      }
    },
    async getTicketType() {
      let loader;
      try {
        loader = this.$loading.show();
        const response = await MasterService.GetActiveList({
          tableName: "ms_ticket_type",
          tt_is_active: "Y",
        });
        const { data } = response;
        if (data.status && data.Records.length > 0) {
          this.masterData.ticketTypesData = [...data.Records];
        } else {
          // Show Errors
          console.log("show error:", data.message);
        }
      } catch (error) {
        this._CatchError(error);
      } finally {
        if (loader) {
          loader.hide();
        }
      }
    },
    async getOfferGroupType() {
      let loader;
      try {
        loader = this.$loading.show();
        const response = await MarketingService.GetAllOfferGroupType({
          status: "Active",
        });
        const { data } = response;
        if (data.status && data.Records.length > 0) {
          this.masterData.offerGroupTypes = data.Records;
        } else {
          console.log("Error:", data.message);
          this.$toasted.show(data.message);
        }
      } catch (err) {
        console.log("Error:", err);
      } finally {
        if (loader) {
          loader.hide();
        }
      }
    },
    async getMovieFormats() {
      let loader;
      try {
        loader = this.$loading.show();
        const response = await MasterService.GetActiveList({
          tableName: "ms_movie_formats",
          mf_is_active: "Y",
        });
        const { data } = response;
        if (data.status && data.Records.length > 0) {
          this.masterData.movieFormats = data.Records;
        } else {
          // Show Errors
          this.$toasted.show(data.message);
          console.log("show error:", data.message);
        }
      } catch (error) {
        this._CatchError(error);
      } finally {
        if (loader) {
          loader.hide();
        }
      }
    },
    handleMovieApplicableChange(selected) {
      this.offerMovieConfiguration.movies_applicable_status = selected;
      if (selected === "movies_applicable") {
        this.offerMovieConfiguration.os_is_movie_applicable = "Y";
      } else if (selected === "movies_not_applicable") {
        this.offerMovieConfiguration.os_is_movie_applicable = "N";
      }
    },
    handleRadioChange(selected) {
      if (selected === "gross") {
        this.redemptionOutletData.offer_applicable_on_gross_amount = "Y";
        this.redemptionOutletData.offer_applicable_on_net_amount = "N";
      } else if (selected === "net") {
        this.redemptionOutletData.offer_applicable_on_gross_amount = "N";
        this.redemptionOutletData.offer_applicable_on_net_amount = "Y";
      }
    },
    async getActiveMovies() {
      this.masterData.movieList = [];
      let loader;
      try {
        loader = this.$loading.show();
        const response = await MovieService.GetActiveMoviesWithFormat({
          movieversions: "Y",
        });
        const { data } = response;
        if (data.status && data.Records.length > 0) {
          this.masterData.movieList = data.Records;
        } else {
          this.$toasted.show(data.message || this.AdminError);
        }
      } catch (error) {
        this._CatchError(error);
      } finally {
        if (loader) {
          loader.hide();
        }
      }
    },
    makeActiveInactive: function (event, index, action = "", name = "") {
      if (action == "add") {
        let obj = { ...event };
        // making keys active based on type of updating section
        // name == "movieList" && (obj.pvms_is_active = "Y");
        // name == "fnbDiscountdata" && (obj.is_active = true);
        // name == "cinemaSettings" && (obj.pvcs_is_active="Y")

        if (name === "fnbDiscountdata") {
          let fnbIndex = -1;
          if (this.offerTypes.fnbItemDiscounts[index].pv_fnb_id) {
            fnbIndex = this.sendPayload.fnbDiscountdata.findIndex(
              (row) =>
                row.pv_fnb_id ==
                this.offerTypes.fnbItemDiscounts[index].pv_fnb_id
            );
          }

          if (fnbIndex >= 0) {
            this.sendPayload.fnbDiscountdata[
              fnbIndex
            ].selectedFnbItem = event;
          }
        }
      } else if (action == "remove") {
        if (name == "movieList") {
          let movieIndex = this.sendPayload[name].findIndex(
            (obj) => obj.pvms_id == event.pvms_id
          );
          if (movieIndex >= 0) {
            this.sendPayload[name][movieIndex].pvms_is_active = "N";
            console.log(
              "remove",
              { event, index, name },
              this.sendPayload[name][movieIndex]
            );
          }
        } else {
          let fnbIndex = -1;
          if (this.offerTypes.fnbItemDiscounts[index].pv_fnb_id) {
            fnbIndex = this.sendPayload.fnbDiscountdata.findIndex(
              (row) =>
                row.pv_fnb_id ==
                this.offerTypes.fnbItemDiscounts[index].pv_fnb_id
            );
          }

          if (fnbIndex >= 0) {
            this.sendPayload.fnbDiscountdata[fnbIndex].selectedFnbItem = {};
          }
        }
      }
    },
    handleAllRowNotApplicableStatus(event) {
      console.log("event=>", event);
      this.cinemaSettingsSection.cinemaSettings.forEach((cinemaRow) => {
        cinemaRow.is_settings_applicable = event;

        if (event == "N" && cinemaRow["selectedScreens"].length > 0) {
          cinemaRow["selectedScreens"] = [];
        }
        if (event == "N" && cinemaRow["selectedSeatTypes"].length > 0) {
          cinemaRow["selectedSeatTypes"] = [];
        }
      });
    },
    updateFnbList(index, event, type) {
      if (type == "add") {
        if (event.length) {
          const itemCodes = event.map((item) => item.item_code);
          for (const [index, row] of this.offerTypes[
            "fnbItemDiscounts"
          ].entries()) {
            console.log("row.selectedFnbItem", index, row.selectedFnbItem);
            const isItemCodePresent = row.selectedFnbItem.some(
              (selectedItem) => itemCodes.includes(selectedItem.item_code)
            );

            if (isItemCodePresent) {
              return this.$toasted.show(
                `Some Items already selected in row ${index + 1}`
              );
            } else {
              console.log(`Item code not found in row ${index}`);
            }
          }
          event.forEach((fnb) => {
            const inactiveIndex = this.offerTypes["fnbItemDiscounts"][index][
              "fnbItemForInactive"
            ].findIndex((item) => item.item_code == fnb.item_code);

            if (inactiveIndex >= 0) {
              this.offerTypes["fnbItemDiscounts"][index][
                "selectedFnbItem"
              ].push(
                this.offerTypes["fnbItemDiscounts"][index][
                "fnbItemForInactive"
                ][inactiveIndex]
              );
              this.offerTypes["fnbItemDiscounts"][index][
                "fnbItemForInactive"
              ].splice(inactiveIndex, 1);
            } else {
              // If the itemCode is not present, push the event
              this.offerTypes["fnbItemDiscounts"][index][
                "selectedFnbItem"
              ].push(fnb);
            }
          });
        } else {
          console.log("fnbDosucoynt arr");
          const itemCode = event.item_code;
          console.log(
            "fnbdiscount item array=>",
            this.offerTypes["fnbItemDiscounts"]
          );
          for (const [index, row] of this.offerTypes[
            "fnbItemDiscounts"
          ].entries()) {
            const isItemCodePresent = row.selectedFnbItem.some(
              (selectedItem) => selectedItem.item_code === itemCode
            );

            if (isItemCodePresent) {
              //     this.offerTypes["fnbItemDiscounts"][index][
              //   "selectedFnbItem"
              // ]=  this.offerTypes["fnbItemDiscounts"][index][
              //   "selectedFnbItem"
              // ].filter(item=>item.item_code!=itemCode)
              return this.$toasted.show(
                `Items already selected in row ${index + 1}`
              );
            } else {
              console.log(`Item code not found in row ${index}`);
            }
          }
          const isItemCodePresent = this.offerTypes["fnbItemDiscounts"][
            index
          ]["selectedFnbItem"].some((item) => item.item_code === itemCode);

          if (!isItemCodePresent) {
            const inactiveIndex = this.offerTypes["fnbItemDiscounts"][index][
              "fnbItemForInactive"
            ].findIndex((item) => item.item_code == itemCode);
            if (inactiveIndex >= 0) {
              this.offerTypes["fnbItemDiscounts"][index][
                "selectedFnbItem"
              ].push(
                this.offerTypes["fnbItemDiscounts"][index][
                "fnbItemForInactive"
                ][inactiveIndex]
              );
              this.offerTypes["fnbItemDiscounts"][index][
                "fnbItemForInactive"
              ].splice(inactiveIndex, 1);
            } else {
              // If the itemCode is not present, push the event
              this.offerTypes["fnbItemDiscounts"][index][
                "selectedFnbItem"
              ].push(event);
            }
          }

          this.rejectedFnbItemCode.push(itemCode);
        }
      } else if (type == "remove") {
        if (event.length) {
          let itemCodes = event.map((item) => item_code);
          event.forEach((eventItem) => {
            if (eventItem.pv_fnb_id) {
              this.offerTypes["fnbItemDiscounts"][index][
                "fnbItemForInactive"
              ].push(eventItem);
            }
          });
          this.offerTypes["fnbItemDiscounts"][index][
            "selectedFnbItem"
          ] = this.offerTypes["fnbItemDiscounts"][index][
            "selectedFnbItem"
          ].filter((item) => itemCode.includes(item.item_code));
        } else {
          let itemCode = event.item_code;
          if (event.pv_fnb_id) {
            this.offerTypes["fnbItemDiscounts"][index][
              "fnbItemForInactive"
            ].push(event);
          }
          let findIndex = this.offerTypes["fnbItemDiscounts"][index][
            "selectedFnbItem"
          ].findIndex((item) => item.item_code == itemCode);
          if (findIndex >= 0) {
            this.offerTypes["fnbItemDiscounts"][index][
              "selectedFnbItem"
            ].splice(findIndex, 1);
          }
        }
      }
    },
    async getFnBItemsForFnbDiscountOfferType() {
      try {
        // let loader = this.$loading.show();
        const response = await MarketingService.getFnbItemsForFnbDiscountsOfferType();
        const { data } = response;
        if (data && data.status && data.Records && data.Records.length > 0) {
          // this.masterData.fnbItems = data.Records;
          this.originalFnbItemForFnbDiscount = data.Records;
          const groupedData = _.groupBy(data.Records, "fc_id");

          const transformedData = Object.keys(groupedData).map((fc_id) => {
            const items = groupedData[fc_id];
            return {
              fc_id: parseInt(fc_id),
              fc_name: items[0].fc_category,
              fnbItemsData: items,
            };
          });
          this.fnbItemsForFnbDiscount = transformedData;
          const { fnbItemDiscounts } = this.offerTypes;
          fnbItemDiscounts[0].fnbItemList = transformedData;

          // loader.hide();
        } else {
          this.$toasted.show(data.message || "Opps! Something went wrong");
          // loader.hide();
        }
      } catch (error) {
        this._CatchError(error);
      }
    },
    onChangeFnbItem(event, rowIndex) { },
    onChangeWeekdays: function (event, keyname) {
      this.offerDaysConfiguration.TrueFalseCount = 0;
      const weekDays = this.offerDaysConfiguration.weekDays;
      if (keyname === "selectAll") {
        const newValue = event === "Y" ? "Y" : "N";
        Object.keys(weekDays).forEach((day) => {
          weekDays[day] = newValue;
        });
        this.offerDaysConfiguration.offer_applicable_on_all_day = newValue;
      } else {
        weekDays[keyname] = event;
        if (event === "N" && weekDays["selectAll"] === "Y") {
          weekDays["selectAll"] = "N";
          this.offerDaysConfiguration.offer_applicable_on_all_day = "N";
        } else {
          const allDaysSelected = Object.keys(weekDays).every((day) => {
            return day === "selectAll" || weekDays[day] === "Y";
          });

          weekDays["selectAll"] = allDaysSelected ? "Y" : "N";
          this.offerDaysConfiguration.offer_applicable_on_all_day = allDaysSelected
            ? "Y"
            : "N";
        }
      }
      Object.keys(weekDays).map((x) => {
        if (x != "selectAll") {
          if (weekDays[x] === "N") {
            this.offerDaysConfiguration.TrueFalseCount++;
          }
        }
      });
    },

    async getClientList() {
      let loader;
      try {
        loader = this.$loading.show();
        const response = await ClientService.GetAllClients({});
        const { data } = response;
        if (data && data.status && data.Records.length > 0) {
          this.masterData.clientList = data.Records;
        } else {
          this.$toasted.show(data.message);
        }
      } catch (error) {
        this.$toasted.show(error);
      } finally {
        if (loader) {
          loader.hide();
        }
      }
    },
    async getUserList() {
      let loader;
      try {
        loader = this.$loading.show();
        const response = await MarketingService.GETUSERLIST();
        const { data } = response;
        console.log("response------>", response);
        if (data && data.status && data.Records && data.Records.length > 0) {
          this.masterData.userList = [...data.Records];
        } else {
          this.$toasted.show(data.message || "Opps! Something went wrong");
        }
      } catch (error) {
        this._CatchError(error);
      } finally {
        if (loader) {
          loader.hide();
        }
      }
    },
    onSelectEmployeeDiscount(event) {
      this.offerSettingConfiguration.selectedOfferType = "fixedDiscount";
    },

    onSelectBankOffer(event) {
      this.offerTypes.is_employee_offer = "N";
      if (event == "N") {
        this.offerSettingConfiguration.bankDetails = {
          selectedBank: "",
          bank_id: null,
          card_type_ids: null,
        };
        this.offerSettingConfiguration.selectedCard = [];
      }
    },
    async getBankList() {
      let loader;
      try {
        loader = this.$loading.show();
        const response = await MarketingService.GetActiveBanks();
        const { data } = response;
        if (data && data.status && data.Records.length > 0) {
          this.masterData.activeBankList = data.Records;
        } else {
          this.$toasted.show(data.message || "Oops! Something went wrong");
        }
      } catch (error) {
        this._CatchError(error);
      } finally {
        if (loader) {
          loader.hide();
        }
      }
    },
    async onSelectBankv2(event) {
      this.offerSettingConfiguration.bankDetails["bank_id"] = null;
      this.offerSettingConfiguration.selectedCard = [];
      this.masterData.activeBankCardList = [];
      this.offerSettingConfiguration.bankDetails["bank_id"] =
        event["bank_id"];
      // this.offerSettingConfiguration.selectedCard = [];

      await this.getBankCards();
    },
    handleMaxDiscount() {
      this.offerTypes.discount.oc_max_discount_amount = this.offerTypes.discount.oc_discount_value;
    },
    async getBankCards() {
      this.masterData.activeBankCardList = [];

      let bankId =
        this.offerSettingConfiguration.bankDetails["bank_id"] || null;
      if (bankId) {
        try {
          const response = await MarketingService.GetActiveBanksCards(
            this.offerSettingConfiguration.bankDetails["bank_id"]
          );
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.masterData.activeBankCardList = data.Records;
            this.offerSettingConfiguration.selectedCard = [];
          } else {
            this.$toasted.show(data.message || "Oops! Something went wrong");
          }
        } catch (error) {
          this._CatchError(error);
        }
      } else {
        this.masterData.activeBankCardList = [];
      }
    },
    onSelectCardTypes(event, type) {
      if (type == "ADD") {
        let IdsArray = this.offerSettingConfiguration.bankDetails[
          "card_type_ids"
        ]
          ? this.offerSettingConfiguration.bankDetails["card_type_ids"].split(
            ", "
          )
          : [];
        IdsArray.push(event["card_id"]);
        if (IdsArray.length) {
          this.offerSettingConfiguration.bankDetails[
            "card_type_ids"
          ] = IdsArray.join(", ");
        }
      } else if (type == "REMOVE") {
        let removeId = event["card_id"] || null;
        let tempArray =
          this.offerSettingConfiguration.bankDetails["selectedCard"] &&
            this.offerSettingConfiguration.bankDetails["selectedCard"].length
            ? this.offerSettingConfiguration.bankDetails[
              "selectedCard"
            ].filter((y) => y.card_id != removeId)
            : [];
        let IdsArray = [];
        if (tempArray.length) {
          IdsArray = tempArray.map((x) => x.card_id);
        }
        if (IdsArray.length) {
          this.offerSettingConfiguration.bankDetails[
            "card_type_ids"
          ] = IdsArray.join(", ");
        } else {
          this.offerSettingConfiguration.bankDetails["card_type_ids"] = null;
        }
      }
    },
    handlePackageOfferChange(event) {
      if (event == "Y") {
        this.offerTypes.selectedOfferType = "buyAndGetCombo";
      }
    },
    checkOfferTypeAvailable(offerType) {
      if (this.offerTypes.is_employee_offer == "Y") {
        if (offerType == "fixedDiscount") {
          return true;
        } else {
          return false;
        }
      } else if (this.offer.is_package_offer == "Y") {
        return ["fixedPriceTicketFnb", "buyAndGetCombo"].includes(offerType);
      } else {
        return true;
      }
    },
    onChangeOfferType(event) {
      if (event == "buyAndGetFreeTickets") {
        this.redemptionOutletData.offer_redeem_at_concession = "N";
      } else if (event == "fixedPriceTicketFnb") {
        this.redemptionOutletData.offer_redeem_at_concession = "N";
      } else if (event == "buyAndgetOffOnAnother") {
        this.redemptionOutletData.offer_redeem_at_concession = "N";
      } else if (event == "fnbItemDiscounts") {
        this.redemptionOutletData.offer_redeem_at_boxoffice = "N";
        this.redemptionOutletData.offer_redeem_at_concession = "Y";
      }
    },
    onChangeChannelWise(event) {
      this.offerTypes.fixedDiscount.oc_min_fnb_price = 0;
    },
    async getFnBItems() {
      let loader;
      try {
        loader = this.$loading.show();
        const response = await MarketingService.GetAllFNBItems();
        const { data } = response;
        if (data && data.status && data.Records && data.Records.length > 0) {
          this.masterData.fnbItems = data.Records;
          // const groupedData = _.groupBy(data.Records, "fc_id");

          // const transformedData = Object.keys(groupedData).map(fc_id => {
          //   const items = groupedData[fc_id];
          //   return {
          //     fc_id: parseInt(fc_id), // Convert fc_id to a number if needed
          //     fc_name: items[0].fc_category, // Assuming fc_name is the same for all items in the group
          //     fnbItemsData: items // The grouped items
          //   };
          // });
          // this.masterData.fnbItems = transformedData;
        } else {
          this.$toasted.show(data.message || "Opps! Something went wrong");
        }
      } catch (error) {
        this._CatchError(error);
      } finally {
        if (loader) {
          loader.hide();
        }
      }
    },
    onChangeCount(event, offerType, type) {
      let value = event.target.value;
      if (offerType == "buyTicketFnbFixedPrice") {
        if (type == "buy") {
          this.offerTypes.buyTicketFnbFixedPrice.oc_max_no_of_ticket_per_transaction = value;
        } else if (type == "max") {
          if (
            value &&
            this.offerTypes.buyTicketFnbFixedPrice.oc_buy_no_of_ticket &&
            parseInt(
              this.offerTypes.buyTicketFnbFixedPrice.oc_buy_no_of_ticket
            ) > parseInt(value)
          ) {
            this.offerTypes.buyTicketFnbFixedPrice.oc_max_no_of_ticket_per_transaction = this.offerTypes.buyTicketFnbFixedPrice.oc_buy_no_of_ticket;
            this.$toasted.show(
              "Max Limit Must be Greater or Equal to No. of Buy Tickets"
            );
            this.$forceUpdate();
          }
        }
      } else if (offerType == "buyAndgetOffOnAnother") {
        if (type == "buy") {
          this.offerTypes.buyAndgetOffOnAnother.oc_max_no_of_ticket_per_transaction = value;
        } else if (type == "max") {
          if (
            value &&
            this.offerTypes.buyAndgetOffOnAnother.oc_buy_no_of_ticket &&
            parseInt(
              this.offerTypes.buyAndgetOffOnAnother.oc_buy_no_of_ticket
            ) > parseInt(value)
          ) {
            this.offerTypes.buyAndgetOffOnAnother.oc_max_no_of_ticket_per_transaction = this.offerTypes.buyAndgetOffOnAnother.oc_buy_no_of_ticket;
            this.$toasted.show(
              "Max Limit Must be Greater or Equal to No. of Buy Tickets"
            );
            this.$forceUpdate();
          }
        }
      }
    },
    selectFnbItemFixedOffer(event, index, type) {
      if (type == "Add") {
        this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data[
          index
        ].oc_buy_item_id = event.item_id;
        this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data[
          index
        ].oc_buy_item_code = event.item_code;
        this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data[
          index
        ].selectedFnbItem = {
          item_id: event.item_id,
          item_name: event.item_name,
          item_code: event.item_code,
        };
      } else if (type == "Remove") {
        this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data[
          index
        ].oc_buy_item_id = null;
        this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data[
          index
        ].oc_buy_item_code = "";
        this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data[
          index
        ].selectedFnbItem = "";
      }
    },
    addFnbCriteria() {
      let fnbObj = {
        oc_buy_no_of_item: null,
        oc_buy_item_id: null,
        oc_buy_item_code: null,
        selectedFnbItem: "",
        oc_fnb_at_price: null,
      };
      this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data.push(fnbObj);
    },
    removeFnbCriteria(index) {
      this.offerTypes.buyTicketFnbFixedPrice.fnb_group_data.splice(index, 1);
    },

    addFnbItemDiscountRow() {
      this.offerTypes.fnbItemDiscounts.push({
        pv_fnb_item_code: "",
        pv_fnb_item_offer: null,
        selectedFnbItem: [],
        fnbItemForInactive: [],
      });
    },
    removeFnbItemDiscountRow(rowIndex) {
      let fnbIndex = -1;
      // if (
      //   this.offerTypes.fnbItemDiscounts[rowIndex] &&
      //   this.offerTypes.fnbItemDiscounts[rowIndex].pv_fnb_id
      // ) {
      //   fnbIndex = this.sendPayload.fnbDiscountdata.findIndex(
      //     row =>
      //       row.pv_fnb_id ==
      //       this.offerTypes.fnbItemDiscounts[rowIndex].pv_fnb_id
      //   );
      // }

      // if (fnbIndex >= 0) {
      //   this.sendPayload.fnbDiscountdata[fnbIndex].pv_fnb_is_active = "N";
      // }
      this.offerTypes["fnbItemDiscounts"][rowIndex].selectedFnbItem.forEach(
        (item) => {
          if (item.pv_fnb_id) {
            this.tempInactiveFnbItem.push(item);
          }
        }
      );
      this.tempInactiveFnbItem.push(
        ...this.offerTypes["fnbItemDiscounts"][rowIndex].fnbItemForInactive
      );

      this.offerTypes.fnbItemDiscounts.splice(rowIndex, 1);
    },
    onChangeTabHandler: function (event, index) {
      this.offerContent.activeIndex = index;
    },
    CheckEmptyContent: function (Content, index) {
      if (Content.langauge.toLowerCase() !== "english") {
        if (Content.offer_title) {
          this.offerContent.notempty[index] = true;
        } else {
          this.offerContent.notempty[index] = false;
        }
      }
    },
    onChangeReporting(event, type) {
      if (type == "full" || type == "full_spcl") {
        this.offerSettingConfiguration.o_reporting_percent = null;
        this.offerSettingConfiguration.has_o_reporting_percent = "N";
      } else if (type == "specific") {
        this.offerSettingConfiguration.report_full_amount_special_rc = "N";
        this.offerSettingConfiguration.report_full_amount = "N";
      }
    },
    setModalData(height, width, contentIndex = null, type = 1) {
      this.offerContent.uploadImageType = type;
      this.offerContent.bannerUpload = false;
      this.$forceUpdate();
      this.offerContent.set_height = height;
      this.offerContent.set_width = width;
      this.offerContent.uploadIndex = contentIndex;
      this.offerContent.showModal = !this.offerContent.showModal;
      if (type == 3) {
        this.signageImageData.cropSizeEnable = false;
      } else {
        this.signageImageData.cropSizeEnable = true;
      }
    },
    onChangeTranslationInput(event, content, contentIndex, item) {
      this.CheckEmptyContent(content, contentIndex);
    },
    async getContentLangauge() {
      let loader;
      try {
        loader = this.$loading.show();
        const response = await MovieService.GetMovieContentLanguages();
        const { data } = response;
        if (data && data.status && data.ContentLanguages.length) {
          this.masterData.ContentLanguages = data.ContentLanguages;
          data.ContentLanguages.forEach((x) => {
            let Obj = {
              ...x,
              offer_title: "",
              offer_description: "",
              offer_banner_image: "",
              offer_poster_image: "",
            };
            this.offerContent.offerContentArray.push(Obj);
          });
        } else {
          this.$toasted.show(data.message);
          console.log("data.message :", data.message);
        }
        // this.makeLangContainers();
      } catch (error) {
        console.log("Catch Error :", error);
      } finally {
        if (loader) {
          loader.hide();
        }
      }
    },

    // makeLangContainers: function () {
    //   this.masterData.ContentLanguages.forEach((x) => {
    //     let Obj = {
    //       ...x,
    //       offer_title: "",
    //       offer_description: "",
    //       offer_banner_image: "",
    //       offer_poster_image: "",
    //     };
    //     this.offerContent.offerContentArray.push(Obj);
    //     console.log(
    //       "this.offerContentArray",
    //       this.offerContent.offerContentArray
    //     );
    //   });
    // },
    onChangeText(event, type) {
      this.offerContent.offerContentArray.map((x) => {
        if (x.langauge.toLowerCase() == "english") {
          if (type == "name") {
            x.offer_title = event.target.value;
          } else if (type == "desc") {
            x.offer_description = event.target.value;
          }
        }
      });
    },
    async getCinemasList() {
      this.masterData.cinemasList = [];
      let loader;
      try {
        loader = this.$loading.show();

        const response = await MasterService.GetActiveList({
          tableName: "ms_cinemas",
          cine_is_active: "Y",
        });
        const { data } = response;
        if (data && data.status && data.Records.length > 0) {
          this.masterData.cinemasList = data.Records;
          console.log("cinema list old=> ", this.masterData.cinemasList);

          this.offerContent.pg_promo_code = data.Records.map((c) => ({
            pg_promo_code: "",
            cine_id: c.cine_id,
            cine_name: c.cine_name,
          }));
        } else {
          this.$toasted.show(data.message || this.AdminError);
        }
      } catch (error) {
        this._CatchError(error);
      } finally {
        if (loader) {
          loader.hide();
        }
      }
    },
    async getCinemaNewList() {
      let loader;
      try {
        let payload = {
          reject_cinema_ids: this.cinemaSettingsSection.rejectedCinemaIds,
        };
        let response = await MarketingService.getCinemaList(payload);
        let { data } = response;
        if (data && data.status && data.Records.length) {
          this.masterData.cinemasList = data.Records;
          return data.Records;
        } else {
          console.log(data.message);
        }
      } catch (error) {
        this._CatchError(error);
      } finally {
        if (loader) {
          loader.hide();
        }
      }
    },
    async updateScreenListCinemaWise(event, index) {
      let loader = this.$loading.show();
      try {
        let cinema_ids = [];

        if (event) {
          cinema_ids = event.map((cinema) => cinema.cine_id).join(",");

          console.log("cinema id arrau fetch function=>", cinema_ids);
          let payload = { cinema_ids };
          let response = await MarketingService.getCinemawiseScreenList(
            payload
          );
          const { data } = response;
          if (data.status && data.Records.length) {
            this.cinemaSettingsSection.cinemaSettings[
              index
            ].allowedScreenList = data.Records;
          } else {
            console.log(data.message);
          }
        } else {
          this.cinemaSettingsSection.cinemaSettings[
            index
          ].allowedScreenList = [];
        }
      } catch (error) {
        this._CatchError(error);
      } finally {
        if (loader) {
          loader.hide();
        }
      }
    },
    async getCinemawiseScreenList(SettingIndex) {
      let loader = this.$loading.show();
      try {
        let cinema_ids = [];

        if (
          this.cinemaSettingsSection.cinemaSettings[SettingIndex]
            .selectedCinema.length
        ) {
          cinema_ids = this.cinemaSettingsSection.cinemaSettings[
            SettingIndex
          ].selectedCinema.map((cinema) => cinema.cine_id);
          // .join(",")
        }

        let payload = { cinema_ids };
        let response = await MarketingService.getCinemawiseScreenList(
          payload
        );
        const { data } = response;
        if (data.status && data.Records.length) {
          this.cinemaSettingsSection.cinemaSettings[
            SettingIndex
          ].allowedScreenList = data.Records;
        } else {
          console.log(data.message);
        }
      } catch (error) {
        this._CatchError(error);
      } finally {
        if (loader) {
          loader.hide();
        }
      }
    },
    async updateRejectedCinemaIds(settingsIndex, event, action) {
      let pvcsIndex = -1;
      if (this.cinemaSettingsSection.cinemaSettings[settingsIndex].pvcs_id) {
        pvcsIndex = this.sendPayload.cinemaSettingsList.findIndex(
          (screenObj) =>
            screenObj.pvcs_id ==
            this.cinemaSettingsSection.cinemaSettings[settingsIndex].pvcs_id
        );
      }
      if (action == "add") {
        this.cinemaSettingsSection.rejectedCinemaIds.push(event.cine_id);
        // await this.getCinemawiseScreenList(settingsIndex);
        if (this.cinemaSettingsSection.cinemaSettings.length) {
          this.cinemaSettingsSection.cinemaSettings.forEach((row) => {
            let cinemaIndex = -1;
            cinemaIndex = row.allowedCinemaList.findIndex(
              (list) => list.cine_id == event.cine_id
            );
            if (cinemaIndex >= 0) {
              row.allowedCinemaList.splice(cinemaIndex, 1);
            }
          });
        }
      } else {
        let idIndex = this.cinemaSettingsSection.rejectedCinemaIds.indexOf(
          event.cine_id
        );
        if (idIndex >= 0) {
          this.cinemaSettingsSection.rejectedCinemaIds.splice(idIndex, 1);
        }
        // await this.getCinemawiseScreenList(settingsIndex)
        this.cinemaSettingsSection.cinemaSettings[
          settingsIndex
        ].selectedScreens = this.cinemaSettingsSection.cinemaSettings[
          settingsIndex
        ].selectedScreens.filter(
          (screen) => screen.cinema_id != event.cine_id
        );

        if (pvcsIndex >= 0) {
          if (
            this.cinemaSettingsSection.cinemaSettings[settingsIndex]
              .selectedScreens.length
          ) {
            this.sendPayload.cinemaSettingsList[
              pvcsIndex
            ].all_screen_ids = this.cinemaSettingsSection.cinemaSettings[
              settingsIndex
            ].selectedScreens
              .map((screen) => screen.screen_id)
              .join(",");
          } else {
            this.sendPayload.cinemaSettingsList[pvcsIndex].all_screen_ids =
              "";
          }
        }
        if (this.cinemaSettingsSection.cinemaSettings.length) {
          this.cinemaSettingsSection.cinemaSettings.forEach((row) => {
            let cinemaIndex = -1;
            cinemaIndex = row.allowedCinemaList.findIndex(
              (list) => list.cine_id == event.cine_id
            );
            if ((cinemaIndex = -1)) {
              row.allowedCinemaList.push(event);
            }
          });
        }
      }
    },
    async updateSendPayloadCinemaSection(settingsIndex, event) {
      let pvcsIndex = -1;
      console.log("event=>", event, "from cinema selection input");
      this.updateScreenListCinemaWise(event, settingsIndex);

      if (this.cinemaSettingsSection.cinemaSettings[settingsIndex].pvcs_id) {
        pvcsIndex = this.sendPayload.cinemaSettingsList.findIndex(
          (screenObj) =>
            screenObj.pvcs_id ==
            this.cinemaSettingsSection.cinemaSettings[settingsIndex].pvcs_id
        );
      }
      if (pvcsIndex >= 0 && event.length) {
        this.sendPayload.cinemaSettingsList[pvcsIndex].all_cinema_id = [
          ...this.sendPayload.cinemaSettingsList[pvcsIndex].all_cinema_id,
          event.cine_id,
        ];
        this.cinemaSettingsSection.availableCinemasList.push(event.cine_id);
      } else {
        this.sendPayload.cinemaSettingsList.push({
          all_cinema_id: event.cine_id,
        });
      }
    },
    updateSendPayload: function (event, index) {
      console.log(
        { event, index },
        this.offerTypes.fnbItemDiscounts,
        this.sendPayload.fnbDiscountdata
      );
      let fnbIndex = -1;
      if (this.offerTypes.fnbItemDiscounts[index].pv_fnb_id) {
        fnbIndex = this.sendPayload.fnbDiscountdata.findIndex(
          (row) =>
            row.pv_fnb_id == this.offerTypes.fnbItemDiscounts[index].pv_fnb_id
        );
      }
      if (fnbIndex >= 0) {
        this.sendPayload.fnbDiscountdata[fnbIndex].pv_fnb_item_offer =
          event.target.value;
      }
    },
    downloadImageSignage(obj, index) {
      let imgPath = obj.imageUrl;
      let fileName = ``;
      let extension_array = imgPath.split(".");
      let actual_extension = extension_array[extension_array.length - 1];
      fileName = `Offer_Signage_${obj.width}x${obj.height}.${actual_extension}`;
      this._downloadImagePath(imgPath, fileName);
    },
    deleteImageSignage(index) {
      this.signageImageData.signageContainer[index].imageUrl = "";
    },
    removeSignage(index) {
      this.signageImageData.signageContainer.splice(index, 1);
    },
    addSignageData() {
      this.signageImageData.signageContainer.push({
        width: "",
        height: "",
        imageUrl: "",
      });
    },
    handleDistributorRowAction(type, index = null) {
      if (type === "add") {
        this.distributorSection.distributorData.push({
          selectedCinema: {},
          selectedSeatTypes: [],
          selectedTickets: [],
          pvds_dist_value: null,
        });
      } else {
        if (this.sendPayload.distributorShareData.length) {
          let pvdsIndex = this.sendPayload.distributorShareData.findIndex(
            (shareObj) =>
              shareObj.pvds_id ==
              this.distributorSection.distributorData[index].pvds_id
          );

          if (pvdsIndex >= 0) {
            this.sendPayload.distributorShareData[pvdsIndex][
              "pvds_is_active"
            ] = "N";
          }
        }
        this.distributorSection.distributorData.splice(index, 1);
      }
    },
    async getOfferPromotionVoucherData() {
      let loader;
      try {
        if (!this.offer_id) {
          this.$toasted.show("offer_id is required");
          return;
        }

        let payload = {
          offer_id: this.offer_id,
        };
        loader = this.$loading.show();
        let response = await MarketingService.getSingleOfferVouchers(payload);
        const { data } = response;

        if (data && data.status) {
          const {
            offerSettings,
            offersContentData,
            moviesData,
            daysData,
            bankOfferData,
            offerCriteriaData,
            cinemaScreenSettingsRecords = [],
            distributorShareData = [],
            promoVoucherCinemaData = {
              data: [],
              availableCinemas: [],
            },
          } = data;

          this.os_is_voucher = offerSettings.os_is_voucher;
          this.titleName =
            offerSettings.os_is_voucher == "Y" ? "Voucher" : "Offer";
          this.offer = {
            os_is_active: offerSettings.os_is_active,
            offer_title: offerSettings.offer_title,
            offer_code: offerSettings.offer_code,
            is_package_offer: offerSettings.is_package_offer,
            offer_start_date_time: offerSettings.offer_start_date_time,
            offer_end_date_time: offerSettings.offer_end_date_time,
            offer_start_time: offerSettings.offer_start_time || "06.00",
            offer_end_time: offerSettings.offer_end_time || "05.59",
            offer_group_type_id: offerSettings.offer_group_type_id,
            offer_description_text: offerSettings.offer_description_text,
            is_offer_auth_required: offerSettings.is_offer_auth_required,
            visible_on_web: offerSettings.visible_on_web,
            is_redemption: offerSettings.is_redemption,
            selectedOfferGroupType: offerSettings.selectedOfferGroupType,
            report_offer: offerSettings["report_offer"] || "N",

          };

          this.offerMovieConfiguration = {
            os_is_foreign_movie_applicable:
              offerSettings.os_is_foreign_movie_applicable,
            os_movie_mf_id: offerSettings.os_movie_mf_id,
            os_is_movie_applicable: offerSettings.os_is_movie_applicable,
            selectedMovieFormats: offerSettings.os_movie_mf_id
              ? this.masterData.movieFormats.filter((obj) =>
                offerSettings.os_movie_mf_id
                  .split(",")
                  .includes(String(obj.mf_id))
              )
              : [],
            // selectedParticularMovies: moviesData.length
            //   ? this.masterData.movieList.filter((obj) =>
            //       moviesData.map((movie) => movie.md_id).includes(obj.md_id)
            //     )
            //   : [],
            selectedParticaularMovies: moviesData.length ? moviesData : [],
            movies_applicable_status:
              offerSettings.os_is_movie_applicable == "Y"
                ? "movies_applicable"
                : "movies_not_applicable",
            start_show_time: moviesData.length
              ? moviesData[0].start_show_time
              : "",
            end_show_time: moviesData.length
              ? moviesData[0].end_show_time
              : "",
            os_time_limit_start: null,
            os_time_limit_end: null
          };

          if (offerSettings["os_time_limit"] && offerSettings["os_time_limit"].split("-").length == 2) {
            this.offerMovieConfiguration.os_time_limit_start = offerSettings["os_time_limit"].split("-")[0]
            this.offerMovieConfiguration.os_time_limit_end = offerSettings["os_time_limit"].split("-")[1]
          }

          this.sendPayload.movieList = moviesData.length ? moviesData : [];
          if (
            promoVoucherCinemaData &&
            promoVoucherCinemaData.data &&
            promoVoucherCinemaData.data.length
          ) {
            this.cinemaSettingsSection.isCinemaSettingsApplicable = "Y";
            this.cinemaSettingsSection.availableCinemasList =
              promoVoucherCinemaData.availableCinemas;
            this.cinemaSettingsSection.cinemaSettings =
              promoVoucherCinemaData.data;
            this.sendPayload.cinemaSettingsList = cinemaScreenSettingsRecords;
            this.cinemaSettingsSection.allCinemaRowNotApplicableStatus =
              promoVoucherCinemaData.data[0]["is_settings_applicable"];
          }

          if (offerSettings.pg_promo_code) {
            let data = JSON.parse(offerSettings.pg_promo_code);
            this.offerContent.pg_promo_code = data;
          }

          if (offersContentData.length) {
            offersContentData.forEach((contentObj) => {
              let masterContentIndex = this.offerContent.offerContentArray.findIndex(
                (masterContentObj) => {
                  return masterContentObj.langaugeId == contentObj.lang_id;
                }
              );

              if (masterContentIndex >= 0) {
                this.offerContent.offerContentArray[masterContentIndex] = {
                  ...this.offerContent.offerContentArray[masterContentIndex],
                  ...contentObj,
                };
              }
            });
          }

          this.voucherSettting = {
            oc_redemptions_per_patron:
              offerCriteriaData.oc_redemptions_per_patron,
            oc_total_redemptions: offerCriteriaData.oc_total_redemptions,
          };

          this.offerDaysConfiguration = {
            offer_applicable_on_all_day:
              offerSettings.offer_applicable_on_all_day,
            weekDays: daysData.sunday
              ? {
                selectAll: offerSettings.offer_applicable_on_all_day,
                ...daysData,
              }
              : {
                selectAll: "Y",
                sunday: "Y",
                monday: "Y",
                tuesday: "Y",
                wednesday: "Y",
                thursday: "Y",
                friday: "Y",
                saturday: "Y",
              },
          };
          this.offerSplitConfiguration = {
            client_share_value: offerSettings.client_share_value,
            client_share_is_percentage:
              offerSettings.client_share_is_percentage,
            offer_dist_share_threshold:
              offerSettings.offer_dist_share_threshold,
            selectedClient: offerSettings.selectedClient || {},
          };
          this.offerSettingConfiguration = {
            is_bank_offer: offerSettings.is_bank_offer,
            report_full_amount: offerSettings.report_full_amount,
            report_full_amount_special_rc:
              offerSettings.report_full_amount_special_rc,
            has_o_reporting_percent: offerSettings.has_o_reporting_percent,
            o_reporting_percent: offerSettings.o_reporting_percent,
            selectedCard: [],
            clientShareSettings: {
              client: null,
              client_share_value: 0,
              is_share_percentage: "Y",
              is_prepaid_voucher: "N",
            },
          };
          (this.offerTypes.is_employee_offer =
            offerSettings.is_employee_offer),
            //start set reemption outlet data

            (this.redemptionOutletData = {
              offer_redeem_at_online: offerSettings.offer_redeem_at_online,
              offer_redeem_at_boxoffice:
                offerSettings.offer_redeem_at_boxoffice,
              offer_redeem_at_concession:
                offerSettings.offer_redeem_at_concession,
              offer_applicable_on:
                offerSettings.offer_applicable_on_gross_amount == "Y"
                  ? "gross"
                  : "net",
              offer_applicable_on_gross_amount:
                offerSettings.offer_applicable_on_gross_amount,
              offer_applicable_on_net_amount:
                offerSettings.offer_applicable_on_net_amount,
              selectedUsers:
                offerSettings.selectedUsers &&
                  offerSettings.selectedUsers.length
                  ? offerSettings.selectedUsers
                  : [],
            });
          //end set reemption outlet data

          //start singage image
          this.signageImageData.signageContainer =
            offerSettings.signage_image;
          //end of signage image

          //start set distributor share  value
          if (distributorShareData.length) {
            this.sendPayload.distributorShareData = distributorShareData;
            distributorShareData.forEach((distributorObj, index) => {
              let distributorShareObject = {
                pvds_id: distributorObj.pvds_id,
                pvds_dist_value: distributorObj.pvds_dist_value,
                pvds_is_active: distributorObj.pvds_is_active,
                selectedCinema: {
                  cine_id: distributorObj.pvds_cinema_id,
                  cine_name: distributorObj.cine_name,
                },
              };
              if (distributorObj.pvds_all_seat_type_id) {
                distributorShareObject.selectedSeatTypes = distributorObj.pvds_all_seat_type_id
                  .split(",")
                  .map((seatObj) => {
                    return this.masterData.seatGroups.length
                      ? this.masterData.seatGroups.find(
                        (cinemaSeatObj) => cinemaSeatObj.sstg_id == seatObj
                      )
                      : { sstg_id: seatObj };
                  });
              }
              if (distributorObj.pvds_ticket_type_id) {
                distributorShareObject.selectedTickets = distributorObj.pvds_ticket_type_id
                  .split(",")
                  .map((ticketObj) => {
                    return this.masterData.ticketTypesData.length
                      ? this.masterData.ticketTypesData.find(
                        (cinemaTicketObj) =>
                          cinemaTicketObj.tt_id == ticketObj
                      )
                      : { tt_id: ticketObj };
                  });
              }

              this.distributorSection.distributorData.push(
                distributorShareObject
              );
            });
          }
          //end set distributor share  value

          if (bankOfferData) {
            if (!this.offerSettingConfiguration.bankDetails) {
              this.offerSettingConfiguration.bankDetails = {
                selectedBank: "",
                bank_id: null,
                card_type_ids: "",
                boc_id: null,
              };
              this.offerSettingConfiguration.selectedCard = [];
            }
            this.offerSettingConfiguration.bankDetails.selectedBank =
              bankOfferData.selectedBank;

            this.offerSettingConfiguration.selectedCard =
              bankOfferData.selectedCards;

            this.offerSettingConfiguration.bankDetails.bank_id =
              bankOfferData.bank_id;

            this.offerSettingConfiguration.bankDetails.boc_id =
              bankOfferData.selectedBank.boc_id;
          }

          if (offerSettings.client_id) {
            this.offerSettingConfiguration.clientShareSettings.client = {
              client_id: offerSettings.client_id,
              client_name: offerSettings.client_name,
              is_prepaid_voucher: offerSettings.is_prepaid_voucher,
            };
            this.offerSettingConfiguration.clientShareSettings.client_share_value =
              offerSettings.client_share_value;
            this.offerSettingConfiguration.clientShareSettings.is_share_percentage =
              offerSettings.client_share_is_percentage;
            this.offerSettingConfiguration.clientShareSettings.is_prepaid_voucher =
              offerSettings.is_prepaid_voucher;
          }

          switch (offerSettings.offer_type_id) {
            case 8:
              this.offerTypes.selectedOfferType = "fixedDiscount";
              this.offerTypes.fixedDiscount = {
                oc_buy_no_of_ticket: offerCriteriaData.oc_buy_no_of_ticket,
                oc_discount_value: offerCriteriaData.oc_discount_value,
                oc_discount_value_is_percentage:
                  offerCriteriaData.oc_discount_value_is_percentage,
                oc_max_discount_amount:
                  offerCriteriaData.oc_max_discount_amount,
                oc_min_ticket_price: offerCriteriaData.oc_min_ticket_price,
                oc_min_fnb_price: offerCriteriaData.oc_min_fnb_price,
                min_amount_channel_wise:
                  offerCriteriaData.min_amount_channel_wise,
              };
              break;
            case 1:
              this.offerTypes.selectedOfferType = "buyAndGetFreeTickets";

              this.offerTypes.buyAndGetFreeTickets = {
                oc_buy_no_of_ticket:
                  offerCriteriaData.oc_buy_no_of_ticket || null,
                oc_get_free_ticket:
                  offerCriteriaData.oc_get_free_ticket || null,
                oc_min_ticket_price:
                  offerCriteriaData.oc_min_ticket_price || null,
                oc_max_no_of_ticket_per_transaction:
                  offerCriteriaData.oc_max_no_of_ticket_per_transaction ||
                  null,
                oc_combine_with_other_offers:
                  offerCriteriaData.oc_combine_with_other_offers || "",
              };
              break;
            case 2:
              this.offerTypes.selectedOfferType = "discount";
              this.offerTypes.discount = {
                oc_buy_no_of_ticket: offerCriteriaData.oc_buy_no_of_ticket,
                oc_discount_value: offerCriteriaData.oc_discount_value,
                oc_discount_value_is_percentage:
                  offerCriteriaData.oc_discount_value_is_percentage,
                oc_max_discount_amount:
                  offerCriteriaData.oc_max_discount_amount,
              };
              break;
            case 7:
              this.offerTypes.selectedOfferType = "loyalitycustomers";
              this.offerTypes.loyalityProgramOffer = {
                oc_buy_no_of_ticket: offerCriteriaData.oc_buy_no_of_ticket,
                oc_discount_value: offerCriteriaData.oc_discount_value,
                oc_discount_value_is_percentage:
                  offerCriteriaData.oc_discount_value_is_percentage,
                oc_max_discount_amount:
                  offerCriteriaData.oc_max_discount_amount,
              };
              break;
            case 3:
              this.offerTypes.selectedOfferType = "buyAndGetCombo";
              this.offerTypes.buyAndGetCombo.offerApplicableAt =
                offerCriteriaData.oc_is_combo_with_fnb == "Y"
                  ? "fAndb"
                  : "boxOffice";
              if (offerCriteriaData.oc_is_combo_with_fnb == "Y") {
                this.offerTypes.buyAndGetCombo.F_And_B = {
                  oc_is_combo: "Y",
                  oc_buy_item_count: offerCriteriaData.oc_buy_item_count,
                  oc_get_item_count: offerCriteriaData.oc_get_item_count,
                  oc_buy_item_id: offerCriteriaData.oc_buy_item_id,
                  oc_get_item_id: offerCriteriaData.oc_get_item_id,
                  oc_get_item_code: offerCriteriaData.oc_get_item_code,
                  oc_is_combo_free: offerCriteriaData.oc_is_combo_free,
                  oc_is_combo_with_fnb:
                    offerCriteriaData.oc_is_combo_with_fnb,
                  oc_discount_value_is_percentage:
                    offerCriteriaData.oc_discount_value_is_percentage,
                  oc_discount_value: offerCriteriaData.oc_discount_value,
                  selectedBuyFnbItem: offerCriteriaData.selectedBuyfnbItem,
                  selectedGetFnbItem: offerCriteriaData.selectedGetfnbItem,
                };
              } else {
                this.offerTypes.buyAndGetCombo.boxOffice = {
                  oc_is_combo: "Y",
                  oc_buy_no_of_ticket: offerCriteriaData.oc_buy_no_of_ticket,
                  oc_get_item_id: offerCriteriaData.oc_get_item_id,
                  oc_get_item_code: offerCriteriaData.oc_get_item_code,
                  oc_is_combo_free: offerCriteriaData.oc_is_combo_free,
                  oc_discount_value: offerCriteriaData.oc_discount_value,
                  oc_discount_value_is_percentage:
                    offerCriteriaData.oc_discount_value_is_percentage,
                  selectedGetFnbItem: offerCriteriaData.selectedGetfnbItem,
                };
              }
              break;
            case 9:
              this.offerTypes.selectedOfferType = "fixedPriceTicketFnb";
              this.offerTypes.buyTicketFnbFixedPrice = {
                oc_buy_no_of_ticket: offerCriteriaData.oc_buy_no_of_ticket,
                // oc_ticket_at_price: offerCriteriaData.oc_ticket_at_price,
                oc_discount_value: offerCriteriaData.oc_discount_value,
                oc_max_no_of_ticket_per_transaction:
                  offerCriteriaData.oc_max_no_of_ticket_per_transaction,
                oc_is_combo_with_fnb: offerCriteriaData.oc_is_combo_with_fnb,
                fnb_group_data: offerCriteriaData.fnb_group_data,
              };
              break;
            case 10:
              this.offerTypes.selectedOfferType = "buyAndgetOffOnAnother";
              this.offerTypes.buyAndgetOffOnAnother = {
                oc_buy_no_of_ticket: offerCriteriaData.oc_buy_no_of_ticket,
                oc_discount_value: offerCriteriaData.oc_discount_value,
                oc_discount_value_is_percentage:
                  offerCriteriaData.oc_discount_value_is_percentage,
                oc_offer_on_higher_amount:
                  offerCriteriaData.oc_offer_on_higher_amount,
                oc_max_no_of_ticket_per_transaction:
                  offerCriteriaData.oc_max_no_of_ticket_per_transaction,
              };
              break;
            case 11:
              this.offerTypes.selectedOfferType = "fnbItemDiscounts";
              if (offerCriteriaData.fnbDiscountData) {
                // this.offerTypes.fnbItemDiscounts =
                //   offerCriteriaData.fnbDiscountData;
                let tempData = _.chain(offerCriteriaData.fnbDiscountData)
                  .groupBy("pv_fnb_item_offer") // Group by 'pv_fnb_item_offer'
                  .map((items, pv_fnb_item_offer) => ({
                    pv_fnb_item_offer: Number(pv_fnb_item_offer),
                    fnbItemForInactive: [],
                    selectedFnbItem: items.map((item) => ({
                      ...item,
                      item_code: item.pv_fnb_item_code, // Rename 'pn_fnb_item_code' to 'item_code'
                    })),
                  }))
                  .value();
                console.log("tempData=>", tempData);
                this.offerTypes.fnbItemDiscounts = tempData;
                this.sendPayload.fnbDiscountdata = offerCriteriaData.fnbDiscountData.map(
                  (row) => {
                    return {
                      ...row,
                      selectedFnbItem: row.selectedFnbItem,
                      fnbItemForInactive: [],
                    };
                  }
                );
              } else {
                this.offerTypes.fnbItemDiscounts = [
                  {
                    pv_fnb_item_code: "",
                    pv_fnb_item_offer: null,
                    selectedFnbItem: [],
                    fnbItemForInactive: [],
                  },
                ];
              }
              break;
            case 12:
              this.offerTypes.selectedOfferType = "freeTickets";
              this.offerTypes.freeTickets.freeTicketCount =
                offerCriteriaData.oc_get_free_ticket;
              this.offerTypes.freeTickets.maxDiscountAmount =
                offerCriteriaData.oc_max_discount_amount || 0;
              this.offerTypes.freeTickets.maxFreeeTicketCount =
                offerCriteriaData.oc_max_no_of_ticket_per_transaction;
              this.offerTypes.freeTickets.isMaxFreeeTicketCount = offerCriteriaData.oc_max_no_of_ticket_per_transaction
                ? "Y"
                : "N";
              break;
          }
        } else {
          this.$toasted.show(data.message);
        }
      } catch (error) {
        this._CatchError(error);
      } finally {
        if (loader) {
          loader.hide();
        }
      }
    },
    updateOffer() {
      this.submit.offer = true;
      if (!this.offer.offer_title) {
        return this.$toasted.show("offer title is required");
      }
      if (
        moment(this.offer.offer_start_date_time, moment.ISO_8601).isAfter(
          moment(this.offer.offer_end_date_time, moment.ISO_8601)
        )
      ) {
        return this.$toasted.show("Please Enter Proper Dates");
      }
      let offers = {
        //offer
        os_is_active: this.offer.os_is_active,
        is_package_offer: this.offer.is_package_offer,
        offer_title: this.offer.offer_title,
        offer_code: this.offer.offer_code,
        offer_group_type_id: this.offer.selectedOfferGroupType
          ? this.offer.selectedOfferGroupType.ogt_id
          : 1,
        offer_start_date_time: `${moment(
          this.offer.offer_start_date_time
        ).format("YYYY-MM-DD")} ${this.offer.offer_start_time
          ? this.offer.offer_start_time
          : moment().format("HH:mm")
          }`,
        offer_end_date_time: `${moment(this.offer.offer_end_date_time).format(
          "YYYY-MM-DD"
        )} ${this.offer.offer_end_time
          ? this.offer.offer_end_time
          : moment().format("HH:mm")
          }`,
        offer_start_time: this.offer.offer_start_time,
        offer_end_time: this.offer.offer_end_time,
        offer_description_text: this.offer.offer_description_text,
        is_offer_auth_required: this.offer.is_offer_auth_required,
        visible_on_web: this.offer.visible_on_web,
        is_redemption: this.offer.is_redemption,
        report_offer: this.offer.report_offer
      };
      let payload = { offers };
      this.onSubmit(payload, "offersSection");
    },
    updateSinage() {
      let offers = {
        signage_image: JSON.stringify(this.signageImageData.signageContainer),
      };
      let payload = { offers };
      this.onSubmit(payload, "signageImageSection");
    },
    updateVoucherSetting() {
      let offerCriteriaData = {
        oc_redemptions_per_patron: this.voucherSettting
          .oc_redemptions_per_patron,
        oc_total_redemptions: this.voucherSettting.oc_total_redemptions,
      };
      let payload = { offerCriteriaData };
      this.onSubmit(payload, "voucherSettingSection");
    },
    async updateMovieSection() {
      if (
        this.offerMovieConfiguration.os_is_movie_applicable == "N" &&
        !this.offerMovieConfiguration.selectedParticaularMovies.length
      ) {
        return this.$toasted.show(
          "Please select atleast one not applicable movie"
        );
      }

      let moviesData = {
        moviesDetails: this.offerMovieConfiguration.selectedParticaularMovies,
        start_show_time: this.offerMovieConfiguration.start_show_time,
        end_show_time: this.offerMovieConfiguration.end_show_time,
      };

      let offersMovieSingleSettings = {
        os_is_foreign_movie_applicable: this.offerMovieConfiguration
          .os_is_foreign_movie_applicable,
        os_movie_mf_id:
          this.offerMovieConfiguration.selectedMovieFormats.length > 0
            ? this.offerMovieConfiguration.selectedMovieFormats
              .map((format) => format.mf_id)
              .join(",")
            : "",
        os_is_movie_applicable: this.offerMovieConfiguration
          .os_is_movie_applicable,
      };
      console.log(this.offerMovieConfiguration.os_time_limit_start, "this.offerMovieConfiguration.os_time_limit_start", this.offerMovieConfiguration.os_time_limit_end)
      if (this.offerMovieConfiguration.os_time_limit_start && this.offerMovieConfiguration.os_time_limit_end) {
        offersMovieSingleSettings = {
          ...offersMovieSingleSettings, os_time_limit_start: this.offerMovieConfiguration.os_time_limit_start["HH"] && this.offerMovieConfiguration.os_time_limit_start["mm"] ? `${this.offerMovieConfiguration.os_time_limit_start["HH"]}:${this.offerMovieConfiguration.os_time_limit_start["mm"]}` : (this.offerMovieConfiguration.os_time_limit_start || null),
          os_time_limit_end: this.offerMovieConfiguration.os_time_limit_end["HH"] && this.offerMovieConfiguration.os_time_limit_end["mm"] ? `${this.offerMovieConfiguration.os_time_limit_end["HH"]}:${this.offerMovieConfiguration.os_time_limit_end["mm"]}` : (this.offerMovieConfiguration.os_time_limit_end || null)
        }
      }
      let newMoviesList = this.offerMovieConfiguration.selectedParticaularMovies.filter(
        (newMoviesObj) => {
          return (
            !newMoviesObj.hasOwnProperty("pvms_id") || !newMoviesObj.pvms_id
          );
        }
      );

      if (newMoviesList.length > 0) {
        this.sendPayload.movieList = [
          ...this.sendPayload.movieList,
          ...newMoviesList,
        ];
      }
      // console.log(this.offerMovieConfiguration.selectedParticaularMovies, "offerMovieConfiguration.selectedParticaularMovies")
      let offersMovie = this.sendPayload.movieList.length
        ? this.sendPayload.movieList.map((offersMovieObj) => {
          let obj = {
            ...offersMovieObj,
            movie_detail_id: offersMovieObj.md_id,
            end_show_time: this.offerMovieConfiguration.end_show_time,
            start_show_time: this.offerMovieConfiguration.start_show_time,
          };
          // if (offersMovieObj.pvms_id) {
          //   obj.pvms_id = offersMovieObj.pvms_id;
          //   obj.offer_id = offersMovieObj.offer_id;
          //   obj.voucher_id = offersMovieObj.voucher_id;
          //   obj.voucher_title = offersMovieObj.offer_title;
          //   obj.movie_detail_id = offersMovieObj.md_id;
          //   obj.offer_start_date_time = offersMovieObj.offer_start_date_time;
          //   obj.start_show_time =
          //     this.offerMovieConfiguration.start_show_time;
          //   obj.offer_end_date_time = offersMovieObj.offer_end_date_time;
          //   obj.end_show_time = this.offerMovieConfiguration.end_show_time;
          //   obj.pvms_is_active = offersMovieObj.pvms_is_active;
          // } else {
          //   obj.voucher_title = this.offer.offer_title;
          //   obj.md_id = offersMovieObj.md_id;
          //   obj.offer_start_date_time = this.offer.offer_start_date_time;
          //   obj.start_show_time =
          //     this.offerMovieConfiguration.start_show_time;
          //   obj.offer_end_date_time = this.offer.offer_end_date_time;
          //   obj.end_show_time = this.offerMovieConfiguration.end_show_time;
          // }
          return obj;
        })
        : [];
      let payload = { offersMovie, offersMovieSingleSettings };

      await this.onSubmit(payload, "offersMovieSection");
      await this.getOfferPromotionVoucherData();
    },

    updateDayssection() {
      if (this.offerDaysConfiguration.TrueFalseCount == 7) {
        return this.$toasted.show("Please select atleast one day of week ");
      }
      let offerDays = this.offerDaysConfiguration.weekDays;
      const { selectAll, ...allWeekDays } = offerDays;
      let payload = {
        offerDays: allWeekDays,
        offers: {
          offer_applicable_on_all_day: this.offerDaysConfiguration
            .offer_applicable_on_all_day,
        },
      };
      this.onSubmit(payload, "offersDaysSection");
    },

    updateSplitConfig() {
      if (!this.offerSplitConfiguration.client_share_value) {
        return this.$toasted.show("Please enter share value ");
      }
      let offersClient = {
        client_id: this.offerSplitConfiguration.selectedClient
          ? this.offerSplitConfiguration.selectedClient.client_id
          : null,
        client_share_value: this.offerSplitConfiguration.client_share_value,
        client_share_is_percentage: this.offerSplitConfiguration
          .client_share_is_percentage,
        offer_dist_share_threshold: this.offerSplitConfiguration
          .offer_dist_share_threshold,
      };
      let payload = { offersClient };
      this.onSubmit(payload, "offersClientSection");
    },
    updateSignageImageSection() { },

    updateotherOffersSettingsSection() {
      if (this.offerSettingConfiguration.is_bank_offer == "Y") {
        if (!this.offerSettingConfiguration.bankDetails.selectedBank) {
          return this.$toasted.show("select bank for bank offer ");
        }
      }
      if (this.offerSettingConfiguration.is_bank_offer == "Y") {
        if (!this.offerSettingConfiguration.selectedCard.length) {
          return this.$toasted.show("select card type");
        }
      }

      let otherSettings = {
        is_bank_offer: this.offerSettingConfiguration.is_bank_offer,
        report_full_amount: this.offerSettingConfiguration.report_full_amount,
        report_full_amount_special_rc: this.offerSettingConfiguration
          .report_full_amount_special_rc,
        has_o_reporting_percent: this.offerSettingConfiguration
          .has_o_reporting_percent,
        o_reporting_percent: this.offerSettingConfiguration
          .o_reporting_percent,
      };

      let bankOfferData = {
        boc_id: this.offerSettingConfiguration.bankDetails.boc_id,
        bank_id: this.offerSettingConfiguration.bankDetails["bank_id"],
        card_type_ids:
          this.offerSettingConfiguration.selectedCard.length > 0
            ? this.offerSettingConfiguration.selectedCard
              .map((card) => card.card_id)
              .join(",")
            : "",
      };
      let offersClient = {
        client_id: null,
        client_share_value: 0,
        client_share_is_percentage: "Y",
      };

      if (
        this.offerSettingConfiguration.clientShareSettings.client &&
        !this.offerSettingConfiguration.clientShareSettings.client_share_value
      ) {
        return this.$toasted.show("Please enter share value ");
      } else {
        offersClient = {
          client_id: this.offerSettingConfiguration.clientShareSettings.client
            ? this.offerSettingConfiguration.clientShareSettings.client
              .client_id
            : null,
          client_share_value: this.offerSettingConfiguration
            .clientShareSettings.client
            ? this.offerSettingConfiguration.clientShareSettings
              .client_share_value
            : null,
          client_share_is_percentage: this.offerSettingConfiguration
            .clientShareSettings.is_share_percentage
            ? this.offerSettingConfiguration.clientShareSettings
              .is_share_percentage
            : this.offerSettingConfiguration.clientShareSettings
              .is_prepaid_voucher == "Y"
              ? "N"
              : "Y",
          is_prepaid_voucher: this.offerSettingConfiguration
            .clientShareSettings.is_prepaid_voucher
            ? this.offerSettingConfiguration.clientShareSettings
              .is_prepaid_voucher
            : null,
        };
      }
      let payload = { otherSettings, bankOfferData };
      if (offersClient.client_id) {
        payload = { ...payload, offersClient };
      }
      this.onSubmit(payload, "otherOffersSettingsSection");
    },
    updateOfferCriteria() {
      let offerCriteriaData = {
        oc_redemptions_per_patron: this.voucherSettting
          .oc_redemptions_per_patron,
        oc_total_redemptions: this.voucherSettting.oc_total_redemptions,
      };
      console.log("check1=>", offerCriteriaData);
      let fnbDiscountData = [];
      let offers = {};

      let validationResponse;
      switch (this.offerTypes.selectedOfferType) {
        case "fixedDiscount":
          validationResponse = this.fixedDiscountValidator();
          if (!validationResponse.status) {
            return this.$toasted.show(validationResponse.mess);
          }
          offerCriteriaData = {
            ...offerCriteriaData,
            ...this.offerTypes.fixedDiscount,
          };
          console.log("check2=>", offerCriteriaData);

          offerCriteriaData.offer_setting_id = this.offer_id;
          offers.offer_type_id = 8;
          offers.is_employee_offer = this.offerTypes.is_employee_offer;

          break;
        case "buyAndGetFreeTickets":
          validationResponse = this.buyAndGetFreeTicketsValidator();
          if (!validationResponse.status) {
            return this.$toasted.show(validationResponse.mess);
          }
          offerCriteriaData = {
            ...offerCriteriaData,
            ...this.offerTypes.buyAndGetFreeTickets,
          };
          console.log("check2=>", offerCriteriaData);

          offerCriteriaData.offer_setting_id = this.offer_id;
          offers.offer_type_id = 1;
          offers.is_employee_offer = "N";

          break;
        case "discount":
          validationResponse = this.discountValidator();
          if (!validationResponse.status) {
            return this.$toasted.show(validationResponse.mess);
          }
          offerCriteriaData = {
            ...offerCriteriaData,
            ...this.offerTypes.discount,
          };
          offerCriteriaData.offer_setting_id = this.offer_id;
          offers.offer_type_id = 2;
          offers.is_employee_offer = "N";

          break;
        case "loyalitycustomers":
          validationResponse = this.loyalitycustomersValidator();
          if (!validationResponse.status) {
            return this.$toasted.show(validationResponse.mess);
          }
          offerCriteriaData = {
            ...offerCriteriaData,
            ...this.offerTypes.loyalityProgramOffer,
          };
          offerCriteriaData.offer_setting_id = this.offer_id;
          offers.offer_type_id = 7;
          offers.is_employee_offer = "N";

          break;
        case "buyAndGetCombo":
          validationResponse = this.buyAndGetComboValidatore();
          if (!validationResponse.status) {
            return this.$toasted.show(validationResponse.mess);
          }
          if (
            this.offerTypes.buyAndGetCombo.offerApplicableAt == "boxOffice"
          ) {
            offerCriteriaData = {
              ...offerCriteriaData,
              ...this.offerTypes.buyAndGetCombo.boxOffice,
            };
            // offerCriteriaData.isBo = true;
            if (this.offerTypes.buyAndGetCombo.boxOffice.selectedGetFnbItem) {
              offerCriteriaData.oc_get_item_count = 1; //buy 1 ticket and get certain fnb for free/price
              offerCriteriaData.oc_get_item_id = this.offerTypes.buyAndGetCombo.boxOffice.selectedGetFnbItem.item_id;
              offerCriteriaData.oc_get_item_code = this.offerTypes.buyAndGetCombo.boxOffice.selectedGetFnbItem.item_code;
              delete offerCriteriaData.selectedGetFnbItem;
            }
          } else {
            offerCriteriaData = {
              ...offerCriteriaData,
              ...this.offerTypes.buyAndGetCombo.F_And_B,
            };
            // offerCriteriaData.isBo = false;

            if (this.offerTypes.buyAndGetCombo.F_And_B.selectedBuyFnbItem) {
              offerCriteriaData.oc_buy_item_id = this.offerTypes.buyAndGetCombo.F_And_B.selectedBuyFnbItem.item_id;
              offerCriteriaData.oc_buy_item_code = this.offerTypes.buyAndGetCombo.F_And_B.selectedBuyFnbItem.item_code;
              delete offerCriteriaData.selectedBuyFnbItem;
            }
            if (this.offerTypes.buyAndGetCombo.F_And_B.selectedGetFnbItem) {
              offerCriteriaData.oc_get_item_id = this.offerTypes.buyAndGetCombo.F_And_B.selectedGetFnbItem.item_id;
              offerCriteriaData.oc_get_item_code = this.offerTypes.buyAndGetCombo.F_And_B.selectedGetFnbItem.item_code;
              delete offerCriteriaData.selectedGetFnbItem;
            }
          }
          offerCriteriaData.oc_is_combo_with_fnb =
            this.offerTypes.buyAndGetCombo.offerApplicableAt == "boxOffice"
              ? "N"
              : "Y";
          offerCriteriaData.offer_setting_id = this.offer_id;
          offers.offer_type_id = 3;
          offers.is_employee_offer = "N";

          break;
        case "fixedPriceTicketFnb":
          validationResponse = this.fixedPriceTicketFnbValidatore();
          if (!validationResponse.status) {
            return this.$toasted.show(validationResponse.mess);
          }

          offerCriteriaData = {
            ...offerCriteriaData,
            ...this.offerTypes.buyTicketFnbFixedPrice,
          };

          let fnbGroupData = offerCriteriaData.fnb_group_data.length
            ? offerCriteriaData.fnb_group_data.map((item) => {
              let obj = { ...item };
              if (item.selectedFnbItem.hasOwnProperty("item_id")) {
                obj.oc_buy_item_id = item.selectedFnbItem.item_id;
                obj.oc_buy_item_code = item.selectedFnbItem.item_code;
              }
              return obj;
            })
            : [];

          offerCriteriaData.fnb_group_data = JSON.stringify(fnbGroupData);
          offerCriteriaData.offer_setting_id = this.offer_id;
          offers.offer_type_id = 9;
          offers.is_employee_offer = "N";
          // Continue with further processing or API call

          break;
        case "buyAndgetOffOnAnother":
          validationResponse = this.buyAndgetOffOnAnotherValidatore();
          if (!validationResponse.status) {
            return this.$toasted.show(validationResponse.mess);
          }
          offerCriteriaData = {
            ...offerCriteriaData,
            ...this.offerTypes.buyAndgetOffOnAnother,
          };
          offerCriteriaData.offer_setting_id = this.offer_id;
          offers.offer_type_id = 10;
          offers.is_employee_offer = "N";

          break;

        case "fnbItemDiscounts":
          // offerCriteriaData = {
          let newFnbData = this.offerTypes.fnbItemDiscounts.filter(
            (fnbRow) => !fnbRow.pv_fnb_id
          );
          console.log("newData=>", newFnbData);
          let allFnbData = [
            ...this.sendPayload.fnbDiscountdata,
            ...newFnbData,
          ];
          // let fnbDiscountData=[];
          let selectedFinalFnbItem = [];
          this.offerTypes.fnbItemDiscounts.forEach((row) => {
            row.selectedFnbItem.forEach((item) => {
              // if(item.pv_fnb_id){
              //   this.tempInactiveFnbItem.push(item)
              // }else{
              selectedFinalFnbItem.push({
                pv_fnb_item_code: item.item_code,
                pv_fnb_id: item.pv_fnb_id ? item.pv_fnb_id : null,
                pv_fnb_item_offer: row.pv_fnb_item_offer,
                pv_fnb_is_active: "Y",
              });
              // }
            });
            row.fnbItemForInactive.forEach((item) => {
              selectedFinalFnbItem.push({ ...item, pv_fnb_is_active: "N" });
            });
          });
          console.log("");
          let modifyTempArray = this.tempInactiveFnbItem.map((item) => {
            return {
              ...item,
              pv_fnb_is_active: "N",
            };
          });

          // if (allFnbData.length) {
          //   fnbDiscountData = allFnbData.map(fnbItem => {
          //     let obj = {
          //       pv_fnb_item_code: "",
          //       pv_fnb_item_offer: null,
          //       pv_fnb_id: null,
          //       pv_fnb_is_active: "Y"
          //     };

          //     fnbItem.selectedFnbItem.hasOwnProperty("item_id") &&
          //       (obj.pv_fnb_item_code = fnbItem.selectedFnbItem.item_code);
          //     fnbItem.pv_fnb_id && (obj.pv_fnb_id = fnbItem.pv_fnb_id);
          //     fnbItem.pv_fnb_is_active &&
          //       (obj.pv_fnb_is_active = fnbItem.pv_fnb_is_active);
          //     obj.pv_fnb_item_offer = fnbItem.pv_fnb_item_offer;

          //     return obj;
          //   });
          // }
          let allItems = [...selectedFinalFnbItem, ...modifyTempArray];
          console.log("last payload data=>", allItems);

          validationResponse = this.fnbItemDiscountsValidatore(allItems);
          console.log("validationResponse=>", validationResponse);
          if (!validationResponse.status) {
            return this.$toasted.show(validationResponse.mess);
          }
          fnbDiscountData = allItems;
          offers.offer_type_id = 11;
          offers.is_employee_offer = "N";
          break;

        case "freeTickets":
          if (!this.offerTypes.freeTickets.freeTicketCount) {
            this.$toasted.show("Minimum 1 free ticket is needed");
            break;
          }
          offers.offer_type_id = 12;
          offerCriteriaData = {
            oc_get_free_ticket: this.offerTypes.freeTickets.freeTicketCount,
            oc_max_no_of_ticket_per_transaction: this.offerTypes.freeTickets
              .maxFreeeTicketCount,
            oc_max_discount_amount: this.offerTypes.freeTickets
              .maxDiscountAmount,
          };
          break;
      }

      let payload = {
        offerCriteriaData: {
          ...offerCriteriaData, oc_redemptions_per_patron: this.voucherSettting
            .oc_redemptions_per_patron,
          oc_total_redemptions: this.voucherSettting.oc_total_redemptions,
        },
        fnbDiscountData,
        offers,
      };
      this.onSubmit(payload, "offerCriteriaSection");
    },
    updateRedemptionOutlet() {
      if (this.redemptionOutletData.selectedUsers.length == 0) {
        return this.$toasted.show(
          `select atleast one user for redemption outlet`
        );
      }
      let offers = {
        offer_redeem_at_online: "Y", //filtering now based on redemption_outlets
        offer_redeem_at_boxoffice: this.redemptionOutletData
          .offer_redeem_at_boxoffice,
        offer_redeem_at_concession: this.redemptionOutletData
          .offer_redeem_at_concession,
        offer_applicable_on_gross_amount: this.redemptionOutletData
          .offer_applicable_on_gross_amount,
        offer_applicable_on_net_amount: this.redemptionOutletData
          .offer_applicable_on_net_amount,
        redemption_outlets: this.redemptionOutletData.selectedUsers.length
          ? this.redemptionOutletData.selectedUsers
            .map((user) => user.user_id)
            .join(",")
          : "",
      };
      let payload = { offers };
      console.log("payoad=>", payload);
      this.onSubmit(payload, "redemptionOutletSection");
    },
    makeUpdatedDistributorShareSectionData(index, type, action = "", event) {
      let pvdsIndex = -1;
      if (this.distributorSection.distributorData[index].pvds_id) {
        pvdsIndex = this.sendPayload.distributorShareData.findIndex(
          (obj) =>
            obj.pvds_id ==
            this.distributorSection.distributorData[index].pvds_id
        );
      }
      if (type == "cinema" && pvdsIndex >= 0) {
        this.sendPayload.distributorShareData[pvdsIndex].pvds_cinema_id =
          event.cine_id;
      } else if (type == "seatTypes" && pvdsIndex >= 0) {
        this.sendPayload.distributorShareData[
          pvdsIndex
        ].pvds_all_seat_type_id = this.distributorSection.distributorData[
          index
        ].selectedSeatTypes.length
            ? this.distributorSection.distributorData[index].selectedSeatTypes
              .map((seatsData) => seatsData.sstg_id)
              .join(",")
            : "";
      } else if (type == "ticketTypes" && pvdsIndex >= 0) {
        this.sendPayload.distributorShareData[
          pvdsIndex
        ].pvds_ticket_type_id = this.distributorSection.distributorData[index]
          .selectedTickets.length
            ? this.distributorSection.distributorData[index].selectedTickets
              .map((ticketsData) => ticketsData.tt_id)
              .join(",")
            : "";
      } else if (type == "shareValue" && pvdsIndex >= 0) {
        this.sendPayload.distributorShareData[
          pvdsIndex
        ].pvds_dist_value = event;
      }
    },
    updateDistributorSection() {
      if (this.distributorSection.distributorData.length) {
        let newDistributorShareData = this.distributorSection.distributorData.filter(
          (distributorObj) => !distributorObj.pvds_id
        );
        if (newDistributorShareData.length) {
          newDistributorShareData.forEach((distributorObj) => {
            let distributorPaydloadObject = {
              pvds_id: null,
              pvds_is_active: "Y",
              pvds_dist_value: distributorObj.pvds_dist_value,
              pvds_cinema_id: distributorObj.selectedCinema.cine_id,

              pvds_all_seat_type_id: distributorObj.selectedSeatTypes.length
                ? distributorObj.selectedSeatTypes
                  .map((seatObj) => seatObj.sstg_id)
                  .join(",")
                : "",

              pvds_ticket_type_id: distributorObj.selectedTickets.length
                ? distributorObj.selectedTickets
                  .map((ticketObj) => ticketObj.tt_id)
                  .join(",")
                : "",
            };
            this.sendPayload.distributorShareData.push(
              distributorPaydloadObject
            );
          });
        }
      }
      let payload = {
        distributorShareData: this.sendPayload.distributorShareData.length
          ? this.sendPayload.distributorShareData
          : [],
      };

      this.onSubmit(payload, "distributorShareSection");
      console.log(this.sendPayload.distributorShareData);
    },
    fixedDiscountValidator() {
      const {
        oc_discount_value,
        oc_max_discount_amount,
      } = this.offerTypes.fixedDiscount;
      if (!oc_discount_value) {
        return { status: false, mess: "enter discount value" };
      } else if (!oc_max_discount_amount) {
        return { status: false, mess: "enter max discount per transection" };
      } else {
        return { status: true, mess: "" };
      }
    },
    buyAndGetFreeTicketsValidator() {
      const {
        oc_buy_no_of_ticket,
        oc_get_free_ticket,
        oc_min_ticket_price,
        oc_max_no_of_ticket_per_transaction,
      } = this.offerTypes.buyAndGetFreeTickets;
      if (!oc_buy_no_of_ticket) {
        return { status: false, mess: "enter buy no of ticket" };
      } else if (!oc_get_free_ticket) {
        return { status: false, mess: "enter get no of free ticket" };
      } else if (!oc_min_ticket_price) {
        return { status: false, mess: "enter min ticket price " };
      } else if (!oc_max_no_of_ticket_per_transaction) {
        return {
          status: false,
          mess: "enter max no of ticket per transection ",
        };
      } else {
        return { status: true, mess: "" };
      }
    },
    discountValidator() {
      const {
        oc_buy_no_of_ticket,
        oc_discount_value,
        oc_max_discount_amount,
      } = this.offerTypes.discount;
      if (!oc_buy_no_of_ticket) {
        return { status: false, mess: "enter buy no of ticket" };
      } else if (!oc_discount_value) {
        return { status: false, mess: "enter discount value" };
      } else if (!oc_max_discount_amount) {
        return { status: false, mess: "enter max discount per transection" };
      } else {
        return { status: true, mess: "" };
      }
    },
    loyalitycustomersValidator() {
      const {
        oc_buy_no_of_ticket,
        oc_discount_value,
        oc_max_discount_amount,
      } = this.offerTypes.loyalityProgramOffer;
      if (!oc_buy_no_of_ticket) {
        return this.$toasted.show("enter buy no of ticket");
      } else if (!oc_discount_value) {
        return { status: false, mess: "enter discount value" };
      } else if (!oc_max_discount_amount) {
        return { status: false, mess: "enter max discount per transection" };
      } else {
        return { status: true, mess: "" };
      }
    },
    buyAndGetComboValidatore() {
      const {
        offerApplicableAt,
        F_And_B,
        boxOffice,
      } = this.offerTypes.buyAndGetCombo;

      if (offerApplicableAt == "fAndb") {
        const {
          oc_buy_item_count,
          oc_get_item_count,
          selectedBuyFnbItem,
          selectedGetFnbItem,
          oc_is_combo_free,
          oc_discount_value,
        } = F_And_B;

        if (!oc_buy_item_count) {
          return { status: false, mess: "enter buy no of item" };
        } else if (
          !selectedBuyFnbItem ||
          !selectedBuyFnbItem.hasOwnProperty("item_id")
        ) {
          return { status: false, mess: "Please select F&B item for Buy" };
        } else if (!oc_get_item_count) {
          return { status: false, mess: "enter get no of item" };
        } else if (
          !selectedGetFnbItem ||
          !selectedGetFnbItem.hasOwnProperty("item_id")
        ) {
          return { status: false, mess: "Please select F&B item for Get" };
        } else if (oc_is_combo_free == "N" && !oc_discount_value) {
          return { status: false, mess: "enter discount value" };
        } else {
          return { status: true, mess: "" };
        }
      } else {
        const {
          oc_buy_no_of_ticket,
          oc_get_item_count,
          selectedGetFnbItem,
          oc_is_combo_free,
          oc_discount_value,
        } = boxOffice;
        if (!oc_buy_no_of_ticket) {
          return { status: false, mess: "enter buy no of ticket" };
        } else if (
          !selectedGetFnbItem ||
          !selectedGetFnbItem.hasOwnProperty("item_id")
        ) {
          return { status: false, mess: "Please select F&B item for Get" };
        } else if (oc_is_combo_free == "N" && !oc_discount_value) {
          return { status: false, mess: "enter discount value" };
        } else {
          return { status: true, mess: "" };
        }
      }
    },
    fixedPriceTicketFnbValidatore() {
      const {
        oc_buy_no_of_ticket,
        oc_discount_value,
        oc_max_no_of_ticket_per_transaction,
        oc_is_combo_with_fnb,
        fnb_group_data,
      } = this.offerTypes.buyTicketFnbFixedPrice;

      if (!oc_buy_no_of_ticket) {
        return { status: false, mess: "enter buy no of ticket" };
      } else if (!oc_discount_value) {
        return { status: false, mess: "enter ticket price" };
      } else if (oc_is_combo_with_fnb == "Y") {
        for (const x of fnb_group_data) {
          if (
            !x.selectedFnbItem ||
            !x.selectedFnbItem.hasOwnProperty("item_id")
          ) {
            return {
              status: false,
              mess: "Please select F&B item for the selected offer type",
            };
          } else if (!x.oc_buy_no_of_item) {
            return {
              status: false,
              mess: "Please enter buy number of items",
            };
          } else if (!x.oc_fnb_at_price) {
            return {
              status: false,
              mess: "Please enter buy item price",
            };
          }
          return { status: true, mess: "" };
        }
      } else {
        return { status: true, mess: "" };
      }
    },
    buyAndgetOffOnAnotherValidatore() {
      const {
        oc_buy_no_of_ticket,
        oc_discount_value,
        oc_max_no_of_ticket_per_transaction,
      } = this.offerTypes.buyAndgetOffOnAnother;
      if (!oc_buy_no_of_ticket) {
        return { status: false, mess: "enter buy no of ticket" };
      } else if (!oc_discount_value) {
        return {
          status: false,
          mess: "enter discount value on another ticket",
        };
      } else if (!oc_max_no_of_ticket_per_transaction) {
        return { status: false, mess: "enter max no of ticket limit" };
      } else {
        return { status: true, mess: "" };
      }
    },
    fnbItemDiscountsValidatore(fnbDiscountData) {
      const { fnbItemDiscounts } = this.offerTypes;
      console.log("fnbItemDiscounts=>", fnbItemDiscounts);
      console.log("fnbDiscountData", fnbDiscountData);
      let checkForActiveFnbItem = fnbDiscountData.filter(
        (item) => item.pv_fnb_is_active == "Y"
      );
      if (!checkForActiveFnbItem.length) {
        return {
          status: false,
          mess: "Select F&B item for F&B item discounts offer.",
        };
      }
      if (fnbItemDiscounts.length) {
        for (let item of fnbDiscountData) {
          if (!item.pv_fnb_item_offer) {
            return {
              status: false,
              mess: "emter offer value for fnb item",
            };
          }
        }
      }
      if (fnbDiscountData.length) {
        let checkforActiveFnbRow = fnbDiscountData.some(
          (item) => item.pv_fnb_is_active === "Y"
        );
        if (!checkforActiveFnbRow) {
          return { status: false, mess: "selected fnb item for each row" };
        } else {
          return { status: true, mess: "" };
        }
      } else {
        return { status: false, mess: "fnb discount data requird" };
      }
    },

    updateOfferContent() {
      let offersContent = this.offerContent.offerContentArray;
      let offers = {
        signage_image: JSON.stringify(this.signageImageData.signageContainer),
      };
      let payload = { offersContent, offers };
      this.onSubmit(payload, "offerContentSection");
    },

    async onSubmit(payload = {}, section = "") {
      let loader = this.$loading.show();
      try {
        payload.metaData = {
          os_id: this.offer_id,
          updateSection: section,
          offer_title: this.offer.offer_tite,
        };
        let response = await MarketingService.editOfferVoucherNew(payload);
        let { data } = response;
        if (data && data.status) {
          console.log(data);
          loader.hide();
          this.$toasted.show(data.message);
        } else {
          loader.hide();
          console.log(data.message);
          this.$toasted.show(data.message);
        }
      } catch (error) {
        loader.hide();
        this._CatchError(error);
      }
    },
    onFinalSubmit: async function () {
      try {
        let functionArray = [
          this.updateOffer(),
          this.updateOfferContent(),
          this.updateCinemaSettingsSection(),
          this.updateMovieSection(),
          this.updateDayssection(),
          this.updateotherOffersSettingsSection(),
          this.updateOfferCriteria(),
          this.updateRedemptionOutlet(),
          this.updateDistributorSection(),
        ];
        if (this.os_is_voucher == "Y") {
          functionArray.push(this.updateVoucherSetting());
        }
        await Promise.all(functionArray);
        console.log("All sections saved successfully!");
      } catch (error) {
        console.error("Error saving one or more sections:", error);
      }
    },
  },
};
</script>
<style>
.greyBackground {
  background-color: #e9ecef;
  border-radius: 15px;
}

.whiteBackground {
  background-color: white;
  border-radius: 15px;
}

.container {
  position: relative;
  padding: 40px;
  margin-top: 30px;
  border: 1px solid #3876d2;
}

.heading {
  position: absolute;
  top: -0.5em;
  left: 30px;
  margin: 0;
  background: white;
  padding: 0 10px;
  color: #3876d2;
  font-weight: bold;
}

.manual_bill_item .multiselect__tags {
  border-radius: unset !important;
  border: unset !important;
}

.bg-lightprimary {
  background-color: #3876d217;
}

.manual_bill_input input {
  border: none;
  height: 40px;
  margin: 0;
  width: 100%;
  padding-inline: 10px;
}

.manual_bill_input input::placeholder,
.manual_bill_wrapper .multiselect__placeholder {
  font-size: 12px;
  font-style: italic;
}

.subheading-scoped {
  position: absolute;
  top: -0.5em;
  left: 30px;
  margin: 0;
  background: white;
  padding: 0 10px;
  color: #3876d2;
  font-weight: bold;
  font-size: 13px
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/PromotionsAndOffersComponent/editPromotionsAndOffersNew.vue